// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2370A363%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23580000%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23580000%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.table > tbody > tr > td {
  vertical-align: middle;
}

.rounded-l1 {
  border-radius: 3px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

.rounded-l2 {
  border-radius: 6px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

.rounded-l3 {
  border-radius: 9px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

.rounded-l4 {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

.rounded-l5 {
  border-radius: 15px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

.rounded-l6 {
  border-radius: 18px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

.rounded-l7 {
  border-radius: 21px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

.rounded-l8 {
  border-radius: 24px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

.rounded-l9 {
  border-radius: 27px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

.rounded-l10 {
  border-radius: 30px !important;
  overflow: hidden;
  border: 1px solid lightgray !important;
}

nav {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  padding-bottom: 20px !important;
  font-weight: 600 !important;
}

.select2 {
  width: 100% !important;
}

.select2-container .select2-selection--single {
  height: 42px !important;
}

.select2-container .select2-selection--multiple {
  padding-top: 0px;
}

.select2-selection__choice {
  margin-top: 8px !important;
}

.select-checkbox a {
  padding-left: 5px;
}

.select2-selection__choice {
  margin-top: 5px !important;
}

.shaded {
  background-color: rgba(0, 0, 0, 0.05);
}

.replay-controls {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.replay-controls-left {
  flex: 1;
  min-width: 320px;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.replay-slider {
  flex: 1;
  width: 100%;
  accent-color: #045fb0;
}

.replay-play-button {
  min-width: 56px;
}

.replay-date-label {
  font-weight: 600;
  min-width: 220px;
  flex: 0 0 220px;
}

.replay-speed-control {
  min-width: 150px;
}

.replay-speed-control label {
  letter-spacing: 0.05em;
}

.replay-season-controls {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
}

.replay-season-dropdown {
  padding-bottom: 0 !important;
  margin-bottom: 0;
}

.replay-home-controls {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  flex-wrap: wrap;
}

.watch-replay-btn {
  border-color: #045fb0;
  color: #045fb0 !important;
  background-color: rgba(4, 95, 176, 0.08);
  font-weight: 600;
  min-height: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  padding: 0 1.05rem;
  border-radius: 0.5rem;
  box-shadow: inset 0 0 0 1px rgba(4, 95, 176, 0.25);
}

.watch-replay-btn:hover {
  background-color: #045fb0;
  color: #fff !important;
  box-shadow: inset 0 0 0 1px rgba(4, 95, 176, 0.5);
}

.replay-marker-highlight {
  background-color: rgba(4, 95, 176, 0.3);
  box-shadow: inset 0 0 0 2px rgba(4, 95, 176, 0.4);
  animation: replayMarkerPulse 1.6s ease-out forwards;
}

@keyframes replayMarkerPulse {
  0% {
    background-color: rgba(4, 95, 176, 0.45);
    box-shadow: inset 0 0 0 2px rgba(4, 95, 176, 0.5);
  }
  60% {
    background-color: rgba(4, 95, 176, 0.15);
    box-shadow: inset 0 0 0 2px rgba(4, 95, 176, 0.2);
  }
  100% {
    background-color: transparent;
    box-shadow: none;
  }
}
.replay-row-enter {
  animation: replayRowEnter 1.6s ease-out;
  animation-fill-mode: forwards;
}

@keyframes replayRowEnter {
  0% {
    background-color: rgba(4, 95, 176, 0.2);
    transform: translateX(-6px);
  }
  50% {
    background-color: rgba(4, 95, 176, 0.1);
  }
  100% {
    background-color: transparent;
    transform: translateX(0);
  }
}
.short-row {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.no-padding {
  padding: 0px !important;
}

/* Sortable Formset Styles */
.drag-handle {
  text-align: center;
  vertical-align: middle;
  cursor: move;
}
.drag-handle i {
  color: #6c757d;
}

[id\$=-ORDER],
[id\$=-DELETE] {
  display: none;
}

.mittab-dashboard .mittab-table-row:hover {
  background-color: #f8f9fa !important;
  transform: translateY(-1px);
  transition: all 0.2s ease;
}
.mittab-dashboard .mittab-tournament-icon {
  width: 40px;
  height: 40px;
  background: #007bff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.1rem;
}
.mittab-dashboard .mittab-stat-item {
  padding: 1rem;
  border-radius: 8px;
  transition: transform 0.2s ease;
}
.mittab-dashboard .mittab-stat-item:hover {
  transform: translateY(-2px);
}
.mittab-dashboard .mittab-table {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}
.mittab-dashboard .mittab-btn-primary {
  background: #007bff;
  transition: all 0.2s ease;
}
.mittab-dashboard .mittab-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(115, 29, 221, 0.3);
  background: #731DDD;
}
.mittab-dashboard .mittab-refresh-btn {
  transition: all 0.2s ease;
}
.mittab-dashboard .mittab-refresh-btn:hover {
  transform: translateY(-1px);
}

.rankings-card {
  border-radius: 8px;
}
.rankings-card .rankings-warning {
  border-left: 4px solid #ffc107;
}
.rankings-card .form-control:focus {
  border-color: #731DDD;
  box-shadow: 0 0 0 0.2rem rgba(115, 29, 221, 0.25);
}
.rankings-card .btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.card {
  overflow: visible !important;
}

.tab-pane.table-responsive {
  overflow: visible !important;
}

.dropdown-menu {
  z-index: 1050 !important;
}

.outreach-available {
  color: #0d7d3e;
  font-weight: 500;
}

/*!
 * Bootstrap v4.6.2 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #045fb0;
  --secondary: #668586;
  --success: #70A363;
  --info: #E8E8E8;
  --warning: #ffc107;
  --danger: #580000;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #045fb0;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: rgb(2.3, 54.625, 101.2);
  text-decoration: underline;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1, .h1 {
  font-size: 2.25rem;
}

h2, .h2 {
  font-size: 1.8rem;
}

h3, .h3 {
  font-size: 1.575rem;
}

h4, .h4 {
  font-size: 1.35rem;
}

h5, .h5 {
  font-size: 1.125rem;
}

h6, .h6 {
  font-size: 0.9rem;
}

.lead {
  font-size: 1.125rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 0.875em;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.125rem;
}

.blockquote-footer {
  display: block;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: rgb(184.72, 210.2, 232.88);
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: rgb(124.48, 171.8, 213.92);
}

.table-hover .table-primary:hover {
  background-color: rgb(165.3245454545, 197.8363636364, 226.7754545455);
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: rgb(165.3245454545, 197.8363636364, 226.7754545455);
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: rgb(212.16, 220.84, 221.12);
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: rgb(175.44, 191.56, 192.08);
}

.table-hover .table-secondary:hover {
  background-color: rgb(197.9209489051, 209.4859854015, 209.8590510949);
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: rgb(197.9209489051, 209.4859854015, 209.8590510949);
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: rgb(214.96, 229.24, 211.32);
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: rgb(180.64, 207.16, 173.88);
}

.table-hover .table-success:hover {
  background-color: rgb(200.2563709677, 219.7803225806, 195.2796774194);
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: rgb(200.2563709677, 219.7803225806, 195.2796774194);
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: rgb(248.56, 248.56, 248.56);
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: rgb(243.04, 243.04, 243.04);
}

.table-hover .table-info:hover {
  background-color: rgb(235.81, 235.81, 235.81);
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: rgb(235.81, 235.81, 235.81);
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: rgb(255, 237.64, 185.56);
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: rgb(255, 222.76, 126.04);
}

.table-hover .table-warning:hover {
  background-color: rgb(255, 231.265, 160.06);
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: rgb(255, 231.265, 160.06);
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: rgb(208.24, 183.6, 183.6);
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: rgb(168.16, 122.4, 122.4);
}

.table-hover .table-danger:hover {
  background-color: rgb(198.1487677725, 168.1912322275, 168.1912322275);
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: rgb(198.1487677725, 168.1912322275, 168.1912322275);
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: rgb(253.04, 253.32, 253.6);
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: rgb(251.36, 251.88, 252.4);
}

.table-hover .table-light:hover {
  background-color: rgb(238.165, 240.57, 242.975);
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: rgb(238.165, 240.57, 242.975);
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: rgb(198.16, 199.84, 201.52);
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: rgb(149.44, 152.56, 155.68);
}

.table-hover .table-dark:hover {
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: rgb(69.1465517241, 77.125, 85.1034482759);
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: rgb(69.1465517241, 77.125, 85.1034482759);
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(57, 159.375, 250.5);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(4, 95, 176, 0.25);
}
.form-control::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.125rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.7875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #70A363;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(112, 163, 99, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #70A363;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #70A363;
  box-shadow: 0 0 0 0.2rem rgba(112, 163, 99, 0.25);
}

.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #70A363;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #70A363;
  box-shadow: 0 0 0 0.2rem rgba(112, 163, 99, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #70A363;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #70A363;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #70A363;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: rgb(141.4072580645, 181.9193548387, 131.0806451613);
  background-color: rgb(141.4072580645, 181.9193548387, 131.0806451613);
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(112, 163, 99, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #70A363;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #70A363;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #70A363;
  box-shadow: 0 0 0 0.2rem rgba(112, 163, 99, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #580000;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(88, 0, 0, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #580000;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #580000;
  box-shadow: 0 0 0 0.2rem rgba(88, 0, 0, 0.25);
}

.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #580000;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #580000;
  box-shadow: 0 0 0 0.2rem rgba(88, 0, 0, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #580000;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #580000;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #580000;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: darkred;
  background-color: darkred;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(88, 0, 0, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #580000;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #580000;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #580000;
  box-shadow: 0 0 0 0.2rem rgba(88, 0, 0, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.9rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #212529;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(4, 95, 176, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #045fb0;
  border-color: #045fb0;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(3.15, 74.8125, 138.6);
  border-color: rgb(2.8666666667, 68.0833333333, 126.1333333333);
}
.btn-primary:focus, .btn-primary.focus {
  color: #fff;
  background-color: rgb(3.15, 74.8125, 138.6);
  border-color: rgb(2.8666666667, 68.0833333333, 126.1333333333);
  box-shadow: 0 0 0 0.2rem rgba(41.65, 119, 187.85, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #045fb0;
  border-color: #045fb0;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(2.8666666667, 68.0833333333, 126.1333333333);
  border-color: rgb(2.5833333333, 61.3541666667, 113.6666666667);
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(41.65, 119, 187.85, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #668586;
  border-color: #668586;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(85.468220339, 111.4438559322, 112.281779661);
  border-color: rgb(79.9576271186, 104.2584745763, 105.0423728814);
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #fff;
  background-color: rgb(85.468220339, 111.4438559322, 112.281779661);
  border-color: rgb(79.9576271186, 104.2584745763, 105.0423728814);
  box-shadow: 0 0 0 0.2rem rgba(124.95, 151.3, 152.15, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #668586;
  border-color: #668586;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(79.9576271186, 104.2584745763, 105.0423728814);
  border-color: rgb(74.4470338983, 97.0730932203, 97.8029661017);
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(124.95, 151.3, 152.15, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #70A363;
  border-color: #70A363;
}
.btn-success:hover {
  color: #fff;
  background-color: rgb(94.7328629032, 140.7459677419, 83.0040322581);
  border-color: rgb(89.3346774194, 132.7258064516, 78.2741935484);
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: rgb(94.7328629032, 140.7459677419, 83.0040322581);
  border-color: rgb(89.3346774194, 132.7258064516, 78.2741935484);
  box-shadow: 0 0 0 0.2rem rgba(133.45, 176.8, 122.4, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #70A363;
  border-color: #70A363;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(89.3346774194, 132.7258064516, 78.2741935484);
  border-color: rgb(83.9364919355, 124.7056451613, 73.5443548387);
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(133.45, 176.8, 122.4, 0.5);
}

.btn-info {
  color: #212529;
  background-color: #E8E8E8;
  border-color: #E8E8E8;
}
.btn-info:hover {
  color: #212529;
  background-color: rgb(212.875, 212.875, 212.875);
  border-color: rgb(206.5, 206.5, 206.5);
}
.btn-info:focus, .btn-info.focus {
  color: #212529;
  background-color: rgb(212.875, 212.875, 212.875);
  border-color: rgb(206.5, 206.5, 206.5);
  box-shadow: 0 0 0 0.2rem rgba(202.15, 202.75, 203.35, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #212529;
  background-color: #E8E8E8;
  border-color: #E8E8E8;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #212529;
  background-color: rgb(206.5, 206.5, 206.5);
  border-color: rgb(200.125, 200.125, 200.125);
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(202.15, 202.75, 203.35, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:hover {
  color: #212529;
  background-color: rgb(223.75, 167.8125, 0);
  border-color: rgb(211, 158.25, 0);
}
.btn-warning:focus, .btn-warning.focus {
  color: #212529;
  background-color: rgb(223.75, 167.8125, 0);
  border-color: rgb(211, 158.25, 0);
  box-shadow: 0 0 0 0.2rem rgba(221.7, 169.6, 12.1, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: rgb(211, 158.25, 0);
  border-color: rgb(198.25, 148.6875, 0);
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(221.7, 169.6, 12.1, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #580000;
  border-color: #580000;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(49.75, 0, 0);
  border-color: #250000;
}
.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: rgb(49.75, 0, 0);
  border-color: #250000;
  box-shadow: 0 0 0 0.2rem rgba(113.05, 38.25, 38.25, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #580000;
  border-color: #580000;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #250000;
  border-color: rgb(24.25, 0, 0);
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(113.05, 38.25, 38.25, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:hover {
  color: #212529;
  background-color: rgb(225.6875, 229.875, 234.0625);
  border-color: rgb(218.25, 223.5, 228.75);
}
.btn-light:focus, .btn-light.focus {
  color: #212529;
  background-color: rgb(225.6875, 229.875, 234.0625);
  border-color: rgb(218.25, 223.5, 228.75);
  box-shadow: 0 0 0 0.2rem rgba(215.75, 217.2, 218.65, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(218.25, 223.5, 228.75);
  border-color: rgb(210.8125, 217.125, 223.4375);
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(215.75, 217.2, 218.65, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.btn-dark:focus, .btn-dark.focus {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
  box-shadow: 0 0 0 0.2rem rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(82.45, 87.55, 92.65, 0.5);
}

.btn-outline-primary {
  color: #045fb0;
  border-color: #045fb0;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #045fb0;
  border-color: #045fb0;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(4, 95, 176, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #045fb0;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #045fb0;
  border-color: #045fb0;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(4, 95, 176, 0.5);
}

.btn-outline-secondary {
  color: #668586;
  border-color: #668586;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #668586;
  border-color: #668586;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(102, 133, 134, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #668586;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #668586;
  border-color: #668586;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(102, 133, 134, 0.5);
}

.btn-outline-success {
  color: #70A363;
  border-color: #70A363;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #70A363;
  border-color: #70A363;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(112, 163, 99, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #70A363;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #70A363;
  border-color: #70A363;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(112, 163, 99, 0.5);
}

.btn-outline-info {
  color: #E8E8E8;
  border-color: #E8E8E8;
}
.btn-outline-info:hover {
  color: #212529;
  background-color: #E8E8E8;
  border-color: #E8E8E8;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 232, 232, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #E8E8E8;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #212529;
  background-color: #E8E8E8;
  border-color: #E8E8E8;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 232, 232, 0.5);
}

.btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ffc107;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-danger {
  color: #580000;
  border-color: #580000;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #580000;
  border-color: #580000;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(88, 0, 0, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #580000;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #580000;
  border-color: #580000;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(88, 0, 0, 0.5);
}

.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f8f9fa;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #045fb0;
  text-decoration: none;
}
.btn-link:hover {
  color: rgb(2.3, 54.625, 101.2);
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.9rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(21.6283783784, 24.25, 26.8716216216);
  text-decoration: none;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #045fb0;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.7875rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.35rem;
  padding-left: 1.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.175rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #045fb0;
  background-color: #045fb0;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(4, 95, 176, 0.25);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgb(57, 159.375, 250.5);
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: rgb(106.8666666667, 183.4583333333, 251.6333333333);
  border-color: rgb(106.8666666667, 183.4583333333, 251.6333333333);
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.175rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #adb5bd;
}
.custom-control-label::after {
  position: absolute;
  top: 0.175rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #045fb0;
  background-color: #045fb0;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(4, 95, 176, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(4, 95, 176, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(4, 95, 176, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.175rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(4, 95, 176, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.custom-select:focus {
  border-color: rgb(57, 159.375, 250.5);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(4, 95, 176, 0.25);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.7875rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.125rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgb(57, 159.375, 250.5);
  box-shadow: 0 0 0 0.2rem rgba(4, 95, 176, 0.25);
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(4, 95, 176, 0.25);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(4, 95, 176, 0.25);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(4, 95, 176, 0.25);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #045fb0;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: rgb(106.8666666667, 183.4583333333, 251.6333333333);
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #045fb0;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -moz-appearance: none;
       appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: rgb(106.8666666667, 183.4583333333, 251.6333333333);
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #045fb0;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: rgb(106.8666666667, 183.4583333333, 251.6333333333);
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #045fb0;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.33125rem;
  padding-bottom: 0.33125rem;
  margin-right: 1rem;
  font-size: 1.125rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.125rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0 0%;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    -moz-column-count: 3;
         column-count: 3;
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #045fb0;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: rgb(2.3, 54.625, 101.2);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(4, 95, 176, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #045fb0;
  border-color: #045fb0;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.125rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #045fb0;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: rgb(2.8666666667, 68.0833333333, 126.1333333333);
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(4, 95, 176, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #668586;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: rgb(79.9576271186, 104.2584745763, 105.0423728814);
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(102, 133, 134, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #70A363;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: rgb(89.3346774194, 132.7258064516, 78.2741935484);
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(112, 163, 99, 0.5);
}

.badge-info {
  color: #212529;
  background-color: #E8E8E8;
}
a.badge-info:hover, a.badge-info:focus {
  color: #212529;
  background-color: rgb(206.5, 206.5, 206.5);
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(232, 232, 232, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #ffc107;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #212529;
  background-color: rgb(211, 158.25, 0);
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #580000;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: #250000;
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(88, 0, 0, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #f8f9fa;
}
a.badge-light:hover, a.badge-light:focus {
  color: #212529;
  background-color: rgb(218.25, 223.5, 228.75);
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3.85rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: rgb(2.08, 49.4, 91.52);
  background-color: rgb(204.8, 223, 239.2);
  border-color: rgb(184.72, 210.2, 232.88);
}
.alert-primary hr {
  border-top-color: rgb(165.3245454545, 197.8363636364, 226.7754545455);
}
.alert-primary .alert-link {
  color: rgb(0.9466666667, 22.4833333333, 41.6533333333);
}

.alert-secondary {
  color: rgb(53.04, 69.16, 69.68);
  background-color: rgb(224.4, 230.6, 230.8);
  border-color: rgb(212.16, 220.84, 221.12);
}
.alert-secondary hr {
  border-top-color: rgb(197.9209489051, 209.4859854015, 209.8590510949);
}
.alert-secondary .alert-link {
  color: rgb(30.9976271186, 40.4184745763, 40.7223728814);
}

.alert-success {
  color: rgb(58.24, 84.76, 51.48);
  background-color: rgb(226.4, 236.6, 223.8);
  border-color: rgb(214.96, 229.24, 211.32);
}
.alert-success hr {
  border-top-color: rgb(200.2563709677, 219.7803225806, 195.2796774194);
}
.alert-success .alert-link {
  color: rgb(36.4384732824, 53.0309923664, 32.2090076336);
}

.alert-info {
  color: rgb(120.64, 120.64, 120.64);
  background-color: rgb(250.4, 250.4, 250.4);
  border-color: rgb(248.56, 248.56, 248.56);
}
.alert-info hr {
  border-top-color: rgb(235.81, 235.81, 235.81);
}
.alert-info .alert-link {
  color: rgb(95.14, 95.14, 95.14);
}

.alert-warning {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgb(255, 242.6, 205.4);
  border-color: rgb(255, 237.64, 185.56);
}
.alert-warning hr {
  border-top-color: rgb(255, 231.265, 160.06);
}
.alert-warning .alert-link {
  color: rgb(82.9625954198, 62.7912977099, 2.2774045802);
}

.alert-danger {
  color: rgb(45.76, 0, 0);
  background-color: rgb(221.6, 204, 204);
  border-color: rgb(208.24, 183.6, 183.6);
}
.alert-danger hr {
  border-top-color: rgb(198.1487677725, 168.1912322275, 168.1912322275);
}
.alert-danger .alert-link {
  color: black;
}

.alert-light {
  color: rgb(128.96, 129.48, 130);
  background-color: rgb(253.6, 253.8, 254);
  border-color: rgb(253.04, 253.32, 253.6);
}
.alert-light hr {
  border-top-color: rgb(238.165, 240.57, 242.975);
}
.alert-light .alert-link {
  color: rgb(103.5492351816, 103.98, 104.4107648184);
}

.alert-dark {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(214.4, 215.6, 216.8);
  border-color: rgb(198.16, 199.84, 201.52);
}
.alert-dark hr {
  border-top-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.alert-dark .alert-link {
  color: rgb(4.1779310345, 4.66, 5.1420689655);
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.675rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #045fb0;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #045fb0;
  border-color: #045fb0;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: rgb(2.08, 49.4, 91.52);
  background-color: rgb(184.72, 210.2, 232.88);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(2.08, 49.4, 91.52);
  background-color: rgb(165.3245454545, 197.8363636364, 226.7754545455);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(2.08, 49.4, 91.52);
  border-color: rgb(2.08, 49.4, 91.52);
}

.list-group-item-secondary {
  color: rgb(53.04, 69.16, 69.68);
  background-color: rgb(212.16, 220.84, 221.12);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(53.04, 69.16, 69.68);
  background-color: rgb(197.9209489051, 209.4859854015, 209.8590510949);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(53.04, 69.16, 69.68);
  border-color: rgb(53.04, 69.16, 69.68);
}

.list-group-item-success {
  color: rgb(58.24, 84.76, 51.48);
  background-color: rgb(214.96, 229.24, 211.32);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(58.24, 84.76, 51.48);
  background-color: rgb(200.2563709677, 219.7803225806, 195.2796774194);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(58.24, 84.76, 51.48);
  border-color: rgb(58.24, 84.76, 51.48);
}

.list-group-item-info {
  color: rgb(120.64, 120.64, 120.64);
  background-color: rgb(248.56, 248.56, 248.56);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(120.64, 120.64, 120.64);
  background-color: rgb(235.81, 235.81, 235.81);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(120.64, 120.64, 120.64);
  border-color: rgb(120.64, 120.64, 120.64);
}

.list-group-item-warning {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgb(255, 237.64, 185.56);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgb(255, 231.265, 160.06);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(132.6, 100.36, 3.64);
  border-color: rgb(132.6, 100.36, 3.64);
}

.list-group-item-danger {
  color: rgb(45.76, 0, 0);
  background-color: rgb(208.24, 183.6, 183.6);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(45.76, 0, 0);
  background-color: rgb(198.1487677725, 168.1912322275, 168.1912322275);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(45.76, 0, 0);
  border-color: rgb(45.76, 0, 0);
}

.list-group-item-light {
  color: rgb(128.96, 129.48, 130);
  background-color: rgb(253.04, 253.32, 253.6);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(128.96, 129.48, 130);
  background-color: rgb(238.165, 240.57, 242.975);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(128.96, 129.48, 130);
  border-color: rgb(128.96, 129.48, 130);
}

.list-group-item-dark {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(198.16, 199.84, 201.52);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(27.04, 30.16, 33.28);
  border-color: rgb(27.04, 30.16, 33.28);
}

.close {
  float: right;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: -moz-min-content;
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: -moz-min-content;
    height: min-content;
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.7875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.7875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid rgb(247.35, 247.35, 247.35);
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.9rem;
  background-color: rgb(247.35, 247.35, 247.35);
  border-bottom: 1px solid rgb(234.6, 234.6, 234.6);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #045fb0 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(2.8666666667, 68.0833333333, 126.1333333333) !important;
}

.bg-secondary {
  background-color: #668586 !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(79.9576271186, 104.2584745763, 105.0423728814) !important;
}

.bg-success {
  background-color: #70A363 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(89.3346774194, 132.7258064516, 78.2741935484) !important;
}

.bg-info {
  background-color: #E8E8E8 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(206.5, 206.5, 206.5) !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(211, 158.25, 0) !important;
}

.bg-danger {
  background-color: #580000 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #250000 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(218.25, 223.5, 228.75) !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(29.1379310345, 32.5, 35.8620689655) !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
  border-left: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #045fb0 !important;
}

.border-secondary {
  border-color: #668586 !important;
}

.border-success {
  border-color: #70A363 !important;
}

.border-info {
  border-color: #E8E8E8 !important;
}

.border-warning {
  border-color: #ffc107 !important;
}

.border-danger {
  border-color: #580000 !important;
}

.border-light {
  border-color: #f8f9fa !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  -webkit-user-select: all !important;
     -moz-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
     -moz-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
     -moz-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #045fb0 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: rgb(2.3, 54.625, 101.2) !important;
}

.text-secondary {
  color: #668586 !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: rgb(68.936440678, 89.8877118644, 90.563559322) !important;
}

.text-success {
  color: #70A363 !important;
}

a.text-success:hover, a.text-success:focus {
  color: rgb(78.5383064516, 116.685483871, 68.814516129) !important;
}

.text-info {
  color: #E8E8E8 !important;
}

a.text-info:hover, a.text-info:focus {
  color: rgb(193.75, 193.75, 193.75) !important;
}

.text-warning {
  color: #ffc107 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: rgb(185.5, 139.125, 0) !important;
}

.text-danger {
  color: #580000 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: rgb(11.5, 0, 0) !important;
}

.text-light {
  color: #f8f9fa !important;
}

a.text-light:hover, a.text-light:focus {
  color: rgb(203.375, 210.75, 218.125) !important;
}

.text-dark {
  color: #343a40 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: rgb(17.7068965517, 19.75, 21.7931034483) !important;
}

.text-body {
  color: #212529 !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #dee2e6;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #dee2e6;
  }
}`, "",{"version":3,"sources":["webpack://./apda/assets/css/app.scss","webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAUhB;EACI,sBAAA;AARJ;;AAYI;EACI,6BAAA;EACA,gBAAA;EACA,sCAAA;AATR;;AAMI;EACI,6BAAA;EACA,gBAAA;EACA,sCAAA;AAHR;;AAAI;EACI,6BAAA;EACA,gBAAA;EACA,sCAAA;AAGR;;AANI;EACI,8BAAA;EACA,gBAAA;EACA,sCAAA;AASR;;AAZI;EACI,8BAAA;EACA,gBAAA;EACA,sCAAA;AAeR;;AAlBI;EACI,8BAAA;EACA,gBAAA;EACA,sCAAA;AAqBR;;AAxBI;EACI,8BAAA;EACA,gBAAA;EACA,sCAAA;AA2BR;;AA9BI;EACI,8BAAA;EACA,gBAAA;EACA,sCAAA;AAiCR;;AApCI;EACI,8BAAA;EACA,gBAAA;EACA,sCAAA;AAuCR;;AA1CI;EACI,8BAAA;EACA,gBAAA;EACA,sCAAA;AA6CR;;AAzCA;EACI,+BAAA;EACA,gCAAA;EACA,+BAAA;EACA,2BAAA;AA4CJ;;AAzCA;EACI,sBAAA;AA4CJ;;AAzCA;EACI,uBAAA;AA4CJ;;AAzCA;EACI,gBAAA;AA4CJ;;AAzCA;EACI,0BAAA;AA4CJ;;AAzCA;EACI,iBAAA;AA4CJ;;AAzCA;EACI,0BAAA;AA4CJ;;AAzCA;EACI,qCAAA;AA4CJ;;AAzCA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA4CJ;;AAzCA;EACI,OAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA4CJ;;AAzCA;EACI,OAAA;EACA,WAAA;EACA,qBAAA;AA4CJ;;AAzCA;EACI,eAAA;AA4CJ;;AAzCA;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;AA4CJ;;AAzCA;EACI,gBAAA;AA4CJ;;AAzCA;EACI,sBAAA;AA4CJ;;AAzCA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;AA4CJ;;AAzCA;EACI,4BAAA;EACA,gBAAA;AA4CJ;;AAzCA;EACI,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;AA4CJ;;AAzCA;EACI,qBAAA;EACA,yBAAA;EACA,wCAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kDAAA;AA4CJ;;AAzCA;EACI,yBAAA;EACA,sBAAA;EACA,iDAAA;AA4CJ;;AAzCA;EACI,uCAAA;EACA,iDAAA;EACA,mDAAA;AA4CJ;;AAzCA;EACI;IACI,wCAAA;IACA,iDAAA;EA4CN;EA1CE;IACI,wCAAA;IACA,iDAAA;EA4CN;EA1CE;IACI,6BAAA;IACA,gBAAA;EA4CN;AACF;AAzCA;EACI,uCAAA;EACA,6BAAA;AA2CJ;;AAxCA;EACI;IACI,uCAAA;IACA,2BAAA;EA2CN;EAzCE;IACI,uCAAA;EA2CN;EAzCE;IACI,6BAAA;IACA,wBAAA;EA2CN;AACF;AAxCA;EACI,2BAAA;EACA,8BAAA;AA0CJ;;AAvCA;EACI,uBAAA;AA0CJ;;AAvCA,4BAAA;AAGA;EACI,kBAAA;EACA,sBAAA;EACA,YAAA;AAwCJ;AAtCI;EACI,cAAA;AAwCR;;AApCA;;EAEI,aAAA;AAuCJ;;AAnCI;EACI,oCAAA;EACA,2BAAA;EACA,yBAAA;AAsCR;AAnCI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AAqCR;AAlCI;EACI,aAAA;EACA,kBAAA;EACA,+BAAA;AAoCR;AAlCQ;EACI,2BAAA;AAoCZ;AAhCI;EACI,wCAAA;EACA,kBAAA;EACA,gBAAA;AAkCR;AA/BI;EACI,mBAAA;EACA,yBAAA;AAiCR;AA/BQ;EACI,2BAAA;EACA,6CAAA;EACA,mBAAA;AAiCZ;AA7BI;EACI,yBAAA;AA+BR;AA7BQ;EACI,2BAAA;AA+BZ;;AA1BA;EACI,kBAAA;AA6BJ;AA3BI;EACI,8BAAA;AA6BR;AA1BI;EACI,qBAAA;EACA,iDAAA;AA4BR;AAzBI;EACI,2BAAA;AA2BR;;AAvBA;EACI,4BAAA;AA0BJ;;AAvBA;EACI,4BAAA;AA0BJ;;AAvBA;EACI,wBAAA;AA0BJ;;AAvBA;EACI,cAAA;EACA,gBAAA;AA0BJ;;AC1TA;;;;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,kOAAA;EACA,6GAAA;AF8UF;;AG7UA;;;EAGE,sBAAA;AHgVF;;AG7UA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AHgVF;;AG1UA;EACE,cAAA;AH6UF;;AGnUA;EACE,SAAA;EACA,qNCsO4B;ECjGxB,iBAAA;EFnIJ,gBC+O4B;ED9O5B,gBCmP4B;EDlP5B,cCnCS;EDoCT,gBAAA;EACA,sBC9CS;AJoXX;;AG1TA;EACE,qBAAA;AH6TF;;AGpTA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AHuTF;;AG1SA;EACE,aAAA;EACA,qBCiN4B;AJ4F9B;;AGtSA;EACE,aAAA;EACA,mBCoF0B;AJqN5B;;AG9RA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,sCAAA;UAAA,8BAAA;AHiSF;;AG9RA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHiSF;;AG9RA;;;EAGE,aAAA;EACA,mBAAA;AHiSF;;AG9RA;;;;EAIE,gBAAA;AHiSF;;AG9RA;EACE,gBCkJ4B;AJ+I9B;;AG9RA;EACE,qBAAA;EACA,cAAA;AHiSF;;AG9RA;EACE,gBAAA;AHiSF;;AG9RA;;EAEE,mBCqI4B;AJ4J9B;;AG9RA;EEII,cAAA;AL8RJ;;AGzRA;;EAEE,kBAAA;EEPE,cAAA;EFSF,cAAA;EACA,wBAAA;AH4RF;;AGzRA;EAAM,eAAA;AH6RN;;AG5RA;EAAM,WAAA;AHgSN;;AGzRA;EACE,cCXwC;EDYxC,qBCXwC;EDYxC,6BAAA;AH4RF;AM5cE;EHmLE,8BCdsC;EDetC,0BCdsC;AJ0S1C;;AGnRA;EACE,cAAA;EACA,qBAAA;AHsRF;AMrdE;EHkME,cAAA;EACA,qBAAA;AHsRJ;;AG7QA;;;;EAIE,iGC0D4B;EClH1B,cAAA;ALyUJ;;AG7QA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AH2QF;;AGnQA;EAEE,gBAAA;AHqQF;;AG7PA;EACE,sBAAA;EACA,kBAAA;AHgQF;;AG7PA;EAGE,gBAAA;EACA,sBAAA;AH8PF;;AGtPA;EACE,yBAAA;AHyPF;;AGtPA;EACE,oBC8E4B;ED7E5B,uBC6E4B;ED5E5B,cCtQS;EDuQT,gBAAA;EACA,oBAAA;AHyPF;;AGlPA;EAEE,mBAAA;EACA,gCAAA;AHoPF;;AG5OA;EAEE,qBAAA;EACA,qBC4JsC;AJkFxC;;AGxOA;EAEE,gBAAA;AH0OF;;AGlOA;EACE,UAAA;AHqOF;;AGlOA;;;;;EAKE,SAAA;EACA,oBAAA;EEhKE,kBAAA;EFkKF,oBAAA;AHqOF;;AGlOA;;EAEE,iBAAA;AHqOF;;AGlOA;;EAEE,oBAAA;AHqOF;;AG/NA;EACE,eAAA;AHkOF;;AG5NA;EACE,iBAAA;AH+NF;;AGxNA;;;;EAIE,0BAAA;AH2NF;;AGlNI;;;;EACE,eAAA;AHwNN;;AGlNA;;;;EAIE,UAAA;EACA,kBAAA;AHqNF;;AGlNA;;EAEE,sBAAA;EACA,UAAA;AHqNF;;AGjNA;EACE,cAAA;EAEA,gBAAA;AHmNF;;AGhNA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AH6MF;;AGxMA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EE9OI,iBAAA;EFgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AH2MF;;AGxMA;EACE,wBAAA;AH2MF;;AGvMA;;EAEE,YAAA;AH0MF;;AGvMA;EAKE,oBAAA;EACA,wBAAA;AHsMF;;AG/LA;EACE,wBAAA;AHkMF;;AG1LA;EACE,aAAA;EACA,0BAAA;AH6LF;;AGtLA;EACE,qBAAA;AHyLF;;AGtLA;EACE,kBAAA;EACA,eAAA;AHyLF;;AGtLA;EACE,aAAA;AHyLF;;AGpLA;EACE,wBAAA;AHuLF;;AOnpBA;;EAEE,qBHsS4B;EGpS5B,gBHsS4B;EGrS5B,gBHsS4B;AJ+W9B;;AOjpBA;EFqKM,kBAAA;ALgfN;;AOppBA;EFoKM,iBAAA;ALofN;;AOvpBA;EFmKM,mBAAA;ALwfN;;AO1pBA;EFkKM,kBAAA;AL4fN;;AO7pBA;EFiKM,mBAAA;ALggBN;;AOhqBA;EFgKM,iBAAA;ALogBN;;AOlqBA;EF8JM,mBAAA;EE5JJ,gBHwS4B;AJ6X9B;;AOjqBA;EFwJM,eAAA;EEtJJ,gBH2R4B;EG1R5B,gBHkR4B;AJkZ9B;;AOlqBA;EFmJM,iBAAA;EEjJJ,gBHuR4B;EGtR5B,gBH6Q4B;AJwZ9B;;AOnqBA;EF8IM,iBAAA;EE5IJ,gBHmR4B;EGlR5B,gBHwQ4B;AJ8Z9B;;AOpqBA;EFyIM,iBAAA;EEvIJ,gBH+Q4B;EG9Q5B,gBHmQ4B;AJoa9B;;AO/pBA;EACE,gBHgFO;EG/EP,mBH+EO;EG9EP,SAAA;EACA,wCAAA;APkqBF;;AO1pBA;;EFkGI,kBAAA;EE/FF,gBH2N4B;AJkc9B;;AO1pBA;;EAEE,cHmQ4B;EGlQ5B,yBH2Q4B;AJkZ9B;;AOrpBA;EC/EE,eAAA;EACA,gBAAA;ARwuBF;;AOrpBA;ECpFE,eAAA;EACA,gBAAA;AR6uBF;;AOvpBA;EACE,qBAAA;AP0pBF;AOxpBE;EACE,oBHqP0B;AJqa9B;;AOhpBA;EF2DI,cAAA;EEzDF,yBAAA;APmpBF;;AO/oBA;EACE,mBHuBO;EC6CH,mBAAA;AL+kBN;;AO/oBA;EACE,cAAA;EF+CE,kBAAA;EE7CF,cH1GS;AJ4vBX;AOhpBE;EACE,aAAA;APkpBJ;;ASrwBA;ECIE,eAAA;EAGA,YAAA;AVmwBF;;ASpwBA;EACE,gBLqgCkC;EKpgClC,sBLRS;EKST,yBAAA;EEEE,sBAAA;EDPF,eAAA;EAGA,YAAA;AV4wBF;;AS9vBA;EAEE,qBAAA;ATgwBF;;AS7vBA;EACE,qBAAA;EACA,cAAA;ATgwBF;;AS7vBA;EJ8HI,cAAA;EI5HF,cL3BS;AJ2xBX;;AYvyBA;EPmKI,gBAAA;EOjKF,cRmCQ;EQlCR,qBAAA;AZ0yBF;AYvyBE;EACE,cAAA;AZyyBJ;;AYpyBA;EACE,sBAAA;EPsJE,gBAAA;EOpJF,WRTS;EQUT,yBRDS;EOEP,qBAAA;AXuyBJ;AYpyBE;EACE,UAAA;EP8IA,eAAA;EO5IA,gBRyQ0B;AJ6hB9B;;AYhyBA;EACE,cAAA;EPqIE,gBAAA;EOnIF,cRjBS;AJozBX;AYhyBE;EPgIE,kBAAA;EO9HA,cAAA;EACA,kBAAA;AZkyBJ;;AY7xBA;EACE,iBRikCkC;EQhkClC,kBAAA;AZgyBF;;Aax0BE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;Adk1BF;;Ae/xBI;EFzCE;IACE,gBT8Le;EJ8oBrB;AACF;AeryBI;EFzCE;IACE,gBT8Le;EJmpBrB;AACF;Ae1yBI;EFzCE;IACE,gBT8Le;EJwpBrB;AACF;Ae/yBI;EFzCE;IACE,iBT8Le;EJ6pBrB;AACF;Aah0BE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;Ads2BF;;Aah0BE;EACE,eAAA;EACA,cAAA;Abm0BJ;Aaj0BI;;EAEE,gBAAA;EACA,eAAA;Abm0BN;;AgBz3BE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AhBi4BJ;;AgB32BM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AhB82BR;;Acl1BE;EACE,cAAA;EACA,eAAA;Adq1BJ;;Acv1BE;EACE,aAAA;EACA,cAAA;Ad01BJ;;Ac51BE;EACE,wBAAA;EACA,yBAAA;Ad+1BJ;;Acj2BE;EACE,aAAA;EACA,cAAA;Ado2BJ;;Act2BE;EACE,aAAA;EACA,cAAA;Ady2BJ;;Ac32BE;EACE,wBAAA;EACA,yBAAA;Ad82BJ;;AgBj4BM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;Ado4BF;;AgBj4BU;EFbR,qBAAA;EAIA,sBAAA;Ad+4BF;;AgBt4BU;EFbR,sBAAA;EAIA,uBAAA;Ado5BF;;AgB34BU;EFbR,aAAA;EAIA,cAAA;Ady5BF;;AgBh5BU;EFbR,sBAAA;EAIA,uBAAA;Ad85BF;;AgBr5BU;EFbR,sBAAA;EAIA,uBAAA;Adm6BF;;AgB15BU;EFbR,aAAA;EAIA,cAAA;Adw6BF;;AgB/5BU;EFbR,sBAAA;EAIA,uBAAA;Ad66BF;;AgBp6BU;EFbR,sBAAA;EAIA,uBAAA;Adk7BF;;AgBz6BU;EFbR,aAAA;EAIA,cAAA;Adu7BF;;AgB96BU;EFbR,sBAAA;EAIA,uBAAA;Ad47BF;;AgBn7BU;EFbR,sBAAA;EAIA,uBAAA;Adi8BF;;AgBx7BU;EFbR,cAAA;EAIA,eAAA;Ads8BF;;AgBv7BM;EAAwB,SAAA;AhB27B9B;;AgBz7BM;EAAuB,SAAA;AhB67B7B;;AgB17BQ;EAAwB,QADb;AhB+7BnB;;AgB97BQ;EAAwB,QADb;AhBm8BnB;;AgBl8BQ;EAAwB,QADb;AhBu8BnB;;AgBt8BQ;EAAwB,QADb;AhB28BnB;;AgB18BQ;EAAwB,QADb;AhB+8BnB;;AgB98BQ;EAAwB,QADb;AhBm9BnB;;AgBl9BQ;EAAwB,QADb;AhBu9BnB;;AgBt9BQ;EAAwB,QADb;AhB29BnB;;AgB19BQ;EAAwB,QADb;AhB+9BnB;;AgB99BQ;EAAwB,QADb;AhBm+BnB;;AgBl+BQ;EAAwB,SADb;AhBu+BnB;;AgBt+BQ;EAAwB,SADb;AhB2+BnB;;AgB1+BQ;EAAwB,SADb;AhB++BnB;;AgBv+BY;EFhBV,wBAAA;Ad2/BF;;AgB3+BY;EFhBV,yBAAA;Ad+/BF;;AgB/+BY;EFhBV,gBAAA;AdmgCF;;AgBn/BY;EFhBV,yBAAA;AdugCF;;AgBv/BY;EFhBV,yBAAA;Ad2gCF;;AgB3/BY;EFhBV,gBAAA;Ad+gCF;;AgB//BY;EFhBV,yBAAA;AdmhCF;;AgBngCY;EFhBV,yBAAA;AduhCF;;AgBvgCY;EFhBV,gBAAA;Ad2hCF;;AgB3gCY;EFhBV,yBAAA;Ad+hCF;;AgB/gCY;EFhBV,yBAAA;AdmiCF;;Ae9hCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhB6jCN;EcjiCA;IACE,cAAA;IACA,eAAA;EdmiCF;EcriCA;IACE,aAAA;IACA,cAAA;EduiCF;EcziCA;IACE,wBAAA;IACA,yBAAA;Ed2iCF;Ec7iCA;IACE,aAAA;IACA,cAAA;Ed+iCF;EcjjCA;IACE,aAAA;IACA,cAAA;EdmjCF;EcrjCA;IACE,wBAAA;IACA,yBAAA;EdujCF;EgB1kCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ed4kCA;EgBzkCQ;IFbR,qBAAA;IAIA,sBAAA;EdslCA;EgB7kCQ;IFbR,sBAAA;IAIA,uBAAA;Ed0lCA;EgBjlCQ;IFbR,aAAA;IAIA,cAAA;Ed8lCA;EgBrlCQ;IFbR,sBAAA;IAIA,uBAAA;EdkmCA;EgBzlCQ;IFbR,sBAAA;IAIA,uBAAA;EdsmCA;EgB7lCQ;IFbR,aAAA;IAIA,cAAA;Ed0mCA;EgBjmCQ;IFbR,sBAAA;IAIA,uBAAA;Ed8mCA;EgBrmCQ;IFbR,sBAAA;IAIA,uBAAA;EdknCA;EgBzmCQ;IFbR,aAAA;IAIA,cAAA;EdsnCA;EgB7mCQ;IFbR,sBAAA;IAIA,uBAAA;Ed0nCA;EgBjnCQ;IFbR,sBAAA;IAIA,uBAAA;Ed8nCA;EgBrnCQ;IFbR,cAAA;IAIA,eAAA;EdkoCA;EgBnnCI;IAAwB,SAAA;EhBsnC5B;EgBpnCI;IAAuB,SAAA;EhBunC3B;EgBpnCM;IAAwB,QADb;EhBwnCjB;EgBvnCM;IAAwB,QADb;EhB2nCjB;EgB1nCM;IAAwB,QADb;EhB8nCjB;EgB7nCM;IAAwB,QADb;EhBioCjB;EgBhoCM;IAAwB,QADb;EhBooCjB;EgBnoCM;IAAwB,QADb;EhBuoCjB;EgBtoCM;IAAwB,QADb;EhB0oCjB;EgBzoCM;IAAwB,QADb;EhB6oCjB;EgB5oCM;IAAwB,QADb;EhBgpCjB;EgB/oCM;IAAwB,QADb;EhBmpCjB;EgBlpCM;IAAwB,SADb;EhBspCjB;EgBrpCM;IAAwB,SADb;EhBypCjB;EgBxpCM;IAAwB,SADb;EhB4pCjB;EgBppCU;IFhBV,cAAA;EduqCA;EgBvpCU;IFhBV,wBAAA;Ed0qCA;EgB1pCU;IFhBV,yBAAA;Ed6qCA;EgB7pCU;IFhBV,gBAAA;EdgrCA;EgBhqCU;IFhBV,yBAAA;EdmrCA;EgBnqCU;IFhBV,yBAAA;EdsrCA;EgBtqCU;IFhBV,gBAAA;EdyrCA;EgBzqCU;IFhBV,yBAAA;Ed4rCA;EgB5qCU;IFhBV,yBAAA;Ed+rCA;EgB/qCU;IFhBV,gBAAA;EdksCA;EgBlrCU;IFhBV,yBAAA;EdqsCA;EgBrrCU;IFhBV,yBAAA;EdwsCA;AACF;AepsCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBkuCN;EctsCA;IACE,cAAA;IACA,eAAA;EdwsCF;Ec1sCA;IACE,aAAA;IACA,cAAA;Ed4sCF;Ec9sCA;IACE,wBAAA;IACA,yBAAA;EdgtCF;EcltCA;IACE,aAAA;IACA,cAAA;EdotCF;EcttCA;IACE,aAAA;IACA,cAAA;EdwtCF;Ec1tCA;IACE,wBAAA;IACA,yBAAA;Ed4tCF;EgB/uCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EdivCA;EgB9uCQ;IFbR,qBAAA;IAIA,sBAAA;Ed2vCA;EgBlvCQ;IFbR,sBAAA;IAIA,uBAAA;Ed+vCA;EgBtvCQ;IFbR,aAAA;IAIA,cAAA;EdmwCA;EgB1vCQ;IFbR,sBAAA;IAIA,uBAAA;EduwCA;EgB9vCQ;IFbR,sBAAA;IAIA,uBAAA;Ed2wCA;EgBlwCQ;IFbR,aAAA;IAIA,cAAA;Ed+wCA;EgBtwCQ;IFbR,sBAAA;IAIA,uBAAA;EdmxCA;EgB1wCQ;IFbR,sBAAA;IAIA,uBAAA;EduxCA;EgB9wCQ;IFbR,aAAA;IAIA,cAAA;Ed2xCA;EgBlxCQ;IFbR,sBAAA;IAIA,uBAAA;Ed+xCA;EgBtxCQ;IFbR,sBAAA;IAIA,uBAAA;EdmyCA;EgB1xCQ;IFbR,cAAA;IAIA,eAAA;EduyCA;EgBxxCI;IAAwB,SAAA;EhB2xC5B;EgBzxCI;IAAuB,SAAA;EhB4xC3B;EgBzxCM;IAAwB,QADb;EhB6xCjB;EgB5xCM;IAAwB,QADb;EhBgyCjB;EgB/xCM;IAAwB,QADb;EhBmyCjB;EgBlyCM;IAAwB,QADb;EhBsyCjB;EgBryCM;IAAwB,QADb;EhByyCjB;EgBxyCM;IAAwB,QADb;EhB4yCjB;EgB3yCM;IAAwB,QADb;EhB+yCjB;EgB9yCM;IAAwB,QADb;EhBkzCjB;EgBjzCM;IAAwB,QADb;EhBqzCjB;EgBpzCM;IAAwB,QADb;EhBwzCjB;EgBvzCM;IAAwB,SADb;EhB2zCjB;EgB1zCM;IAAwB,SADb;EhB8zCjB;EgB7zCM;IAAwB,SADb;EhBi0CjB;EgBzzCU;IFhBV,cAAA;Ed40CA;EgB5zCU;IFhBV,wBAAA;Ed+0CA;EgB/zCU;IFhBV,yBAAA;Edk1CA;EgBl0CU;IFhBV,gBAAA;Edq1CA;EgBr0CU;IFhBV,yBAAA;Edw1CA;EgBx0CU;IFhBV,yBAAA;Ed21CA;EgB30CU;IFhBV,gBAAA;Ed81CA;EgB90CU;IFhBV,yBAAA;Edi2CA;EgBj1CU;IFhBV,yBAAA;Edo2CA;EgBp1CU;IFhBV,gBAAA;Edu2CA;EgBv1CU;IFhBV,yBAAA;Ed02CA;EgB11CU;IFhBV,yBAAA;Ed62CA;AACF;Aez2CI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBu4CN;Ec32CA;IACE,cAAA;IACA,eAAA;Ed62CF;Ec/2CA;IACE,aAAA;IACA,cAAA;Edi3CF;Ecn3CA;IACE,wBAAA;IACA,yBAAA;Edq3CF;Ecv3CA;IACE,aAAA;IACA,cAAA;Edy3CF;Ec33CA;IACE,aAAA;IACA,cAAA;Ed63CF;Ec/3CA;IACE,wBAAA;IACA,yBAAA;Edi4CF;EgBp5CI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Eds5CA;EgBn5CQ;IFbR,qBAAA;IAIA,sBAAA;Edg6CA;EgBv5CQ;IFbR,sBAAA;IAIA,uBAAA;Edo6CA;EgB35CQ;IFbR,aAAA;IAIA,cAAA;Edw6CA;EgB/5CQ;IFbR,sBAAA;IAIA,uBAAA;Ed46CA;EgBn6CQ;IFbR,sBAAA;IAIA,uBAAA;Edg7CA;EgBv6CQ;IFbR,aAAA;IAIA,cAAA;Edo7CA;EgB36CQ;IFbR,sBAAA;IAIA,uBAAA;Edw7CA;EgB/6CQ;IFbR,sBAAA;IAIA,uBAAA;Ed47CA;EgBn7CQ;IFbR,aAAA;IAIA,cAAA;Edg8CA;EgBv7CQ;IFbR,sBAAA;IAIA,uBAAA;Edo8CA;EgB37CQ;IFbR,sBAAA;IAIA,uBAAA;Edw8CA;EgB/7CQ;IFbR,cAAA;IAIA,eAAA;Ed48CA;EgB77CI;IAAwB,SAAA;EhBg8C5B;EgB97CI;IAAuB,SAAA;EhBi8C3B;EgB97CM;IAAwB,QADb;EhBk8CjB;EgBj8CM;IAAwB,QADb;EhBq8CjB;EgBp8CM;IAAwB,QADb;EhBw8CjB;EgBv8CM;IAAwB,QADb;EhB28CjB;EgB18CM;IAAwB,QADb;EhB88CjB;EgB78CM;IAAwB,QADb;EhBi9CjB;EgBh9CM;IAAwB,QADb;EhBo9CjB;EgBn9CM;IAAwB,QADb;EhBu9CjB;EgBt9CM;IAAwB,QADb;EhB09CjB;EgBz9CM;IAAwB,QADb;EhB69CjB;EgB59CM;IAAwB,SADb;EhBg+CjB;EgB/9CM;IAAwB,SADb;EhBm+CjB;EgBl+CM;IAAwB,SADb;EhBs+CjB;EgB99CU;IFhBV,cAAA;Edi/CA;EgBj+CU;IFhBV,wBAAA;Edo/CA;EgBp+CU;IFhBV,yBAAA;Edu/CA;EgBv+CU;IFhBV,gBAAA;Ed0/CA;EgB1+CU;IFhBV,yBAAA;Ed6/CA;EgB7+CU;IFhBV,yBAAA;EdggDA;EgBh/CU;IFhBV,gBAAA;EdmgDA;EgBn/CU;IFhBV,yBAAA;EdsgDA;EgBt/CU;IFhBV,yBAAA;EdygDA;EgBz/CU;IFhBV,gBAAA;Ed4gDA;EgB5/CU;IFhBV,yBAAA;Ed+gDA;EgB//CU;IFhBV,yBAAA;EdkhDA;AACF;Ae9gDI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhB4iDN;EchhDA;IACE,cAAA;IACA,eAAA;EdkhDF;EcphDA;IACE,aAAA;IACA,cAAA;EdshDF;EcxhDA;IACE,wBAAA;IACA,yBAAA;Ed0hDF;Ec5hDA;IACE,aAAA;IACA,cAAA;Ed8hDF;EchiDA;IACE,aAAA;IACA,cAAA;EdkiDF;EcpiDA;IACE,wBAAA;IACA,yBAAA;EdsiDF;EgBzjDI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ed2jDA;EgBxjDQ;IFbR,qBAAA;IAIA,sBAAA;EdqkDA;EgB5jDQ;IFbR,sBAAA;IAIA,uBAAA;EdykDA;EgBhkDQ;IFbR,aAAA;IAIA,cAAA;Ed6kDA;EgBpkDQ;IFbR,sBAAA;IAIA,uBAAA;EdilDA;EgBxkDQ;IFbR,sBAAA;IAIA,uBAAA;EdqlDA;EgB5kDQ;IFbR,aAAA;IAIA,cAAA;EdylDA;EgBhlDQ;IFbR,sBAAA;IAIA,uBAAA;Ed6lDA;EgBplDQ;IFbR,sBAAA;IAIA,uBAAA;EdimDA;EgBxlDQ;IFbR,aAAA;IAIA,cAAA;EdqmDA;EgB5lDQ;IFbR,sBAAA;IAIA,uBAAA;EdymDA;EgBhmDQ;IFbR,sBAAA;IAIA,uBAAA;Ed6mDA;EgBpmDQ;IFbR,cAAA;IAIA,eAAA;EdinDA;EgBlmDI;IAAwB,SAAA;EhBqmD5B;EgBnmDI;IAAuB,SAAA;EhBsmD3B;EgBnmDM;IAAwB,QADb;EhBumDjB;EgBtmDM;IAAwB,QADb;EhB0mDjB;EgBzmDM;IAAwB,QADb;EhB6mDjB;EgB5mDM;IAAwB,QADb;EhBgnDjB;EgB/mDM;IAAwB,QADb;EhBmnDjB;EgBlnDM;IAAwB,QADb;EhBsnDjB;EgBrnDM;IAAwB,QADb;EhBynDjB;EgBxnDM;IAAwB,QADb;EhB4nDjB;EgB3nDM;IAAwB,QADb;EhB+nDjB;EgB9nDM;IAAwB,QADb;EhBkoDjB;EgBjoDM;IAAwB,SADb;EhBqoDjB;EgBpoDM;IAAwB,SADb;EhBwoDjB;EgBvoDM;IAAwB,SADb;EhB2oDjB;EgBnoDU;IFhBV,cAAA;EdspDA;EgBtoDU;IFhBV,wBAAA;EdypDA;EgBzoDU;IFhBV,yBAAA;Ed4pDA;EgB5oDU;IFhBV,gBAAA;Ed+pDA;EgB/oDU;IFhBV,yBAAA;EdkqDA;EgBlpDU;IFhBV,yBAAA;EdqqDA;EgBrpDU;IFhBV,gBAAA;EdwqDA;EgBxpDU;IFhBV,yBAAA;Ed2qDA;EgB3pDU;IFhBV,yBAAA;Ed8qDA;EgB9pDU;IFhBV,gBAAA;EdirDA;EgBjqDU;IFhBV,yBAAA;EdorDA;EgBpqDU;IFhBV,yBAAA;EdurDA;AACF;AiB3uDA;EACE,WAAA;EACA,mBbiIO;EahIP,cbSS;AJouDX;AiB1uDE;;EAEE,gBbmV0B;EalV1B,mBAAA;EACA,6BAAA;AjB4uDJ;AiBzuDE;EACE,sBAAA;EACA,gCAAA;AjB2uDJ;AiBxuDE;EACE,6BAAA;AjB0uDJ;;AiBhuDE;;EAEE,eb6T0B;AJs6C9B;;AiB1tDA;EACE,yBAAA;AjB6tDF;AiB3tDE;;EAEE,yBAAA;AjB6tDJ;AiBztDI;;EAEE,wBAAA;AjB2tDN;;AiBrtDE;;;;EAIE,SAAA;AjBwtDJ;;AiB/sDE;EACE,qCbyR0B;AJy7C9B;;AMjxDE;EW2EI,cbvEK;EawEL,sCb8QwB;AJ47C9B;;AkB5xDI;;;EAGE,4CD2F+B;AjBosDrC;AkB3xDM;;;;EAIE,wCDmFyE;AjB0sDjF;;AMlyDE;EYiBM,qEAJe;AlByxDvB;AkBnxDQ;;EAEE,qEARa;AlB6xDvB;;AkBhzDI;;;EAGE,6CD2F+B;AjBwtDrC;AkB/yDM;;;;EAIE,yCDmFyE;AjB8tDjF;;AMtzDE;EYiBM,qEAJe;AlB6yDvB;AkBvyDQ;;EAEE,qEARa;AlBizDvB;;AkBp0DI;;;EAGE,6CD2F+B;AjB4uDrC;AkBn0DM;;;;EAIE,yCDmFyE;AjBkvDjF;;AM10DE;EYiBM,qEAJe;AlBi0DvB;AkB3zDQ;;EAEE,qEARa;AlBq0DvB;;AkBx1DI;;;EAGE,6CD2F+B;AjBgwDrC;AkBv1DM;;;;EAIE,yCDmFyE;AjBswDjF;;AM91DE;EYiBM,6CAJe;AlBq1DvB;AkB/0DQ;;EAEE,6CARa;AlBy1DvB;;AkB52DI;;;EAGE,0CD2F+B;AjBoxDrC;AkB32DM;;;;EAIE,sCDmFyE;AjB0xDjF;;AMl3DE;EYiBM,2CAJe;AlBy2DvB;AkBn2DQ;;EAEE,2CARa;AlB62DvB;;AkBh4DI;;;EAGE,2CD2F+B;AjBwyDrC;AkB/3DM;;;;EAIE,uCDmFyE;AjB8yDjF;;AMt4DE;EYiBM,qEAJe;AlB63DvB;AkBv3DQ;;EAEE,qEARa;AlBi4DvB;;AkBp5DI;;;EAGE,4CD2F+B;AjB4zDrC;AkBn5DM;;;;EAIE,wCDmFyE;AjBk0DjF;;AM15DE;EYiBM,+CAJe;AlBi5DvB;AkB34DQ;;EAEE,+CARa;AlBq5DvB;;AkBx6DI;;;EAGE,6CD2F+B;AjBg1DrC;AkBv6DM;;;;EAIE,yCDmFyE;AjBs1DjF;;AM96DE;EYiBM,6DAJe;AlBq6DvB;AkB/5DQ;;EAEE,6DARa;AlBy6DvB;;AkB57DI;;;EAGE,sCd6VwB;AJkmD9B;;AM57DE;EYiBM,sCAJe;AlBm7DvB;AkB76DQ;;EAEE,sCARa;AlBu7DvB;;AiB/1DI;EACE,Wb3GK;Ea4GL,yBbpGK;EaqGL,uDbiQwB;AJimD9B;AiB71DI;EACE,cb5GK;Ea6GL,yBblHK;EamHL,qBblHK;AJi9DX;;AiB11DA;EACE,Wb3HS;Ea4HT,yBbpHS;AJi9DX;AiB31DE;;;EAGE,uDb6O0B;AJgnD9B;AiB11DE;EACE,SAAA;AjB41DJ;AiBx1DI;EACE,2CbiOwB;AJynD9B;AM/9DE;EW4IM,WbjJG;EakJH,4Cb2NsB;AJ2nD9B;;Aet6DI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjBw0DN;EiBr0DM;IACE,SAAA;EjBu0DR;AACF;Ael7DI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjBm1DN;EiBh1DM;IACE,SAAA;EjBk1DR;AACF;Ae77DI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjB81DN;EiB31DM;IACE,SAAA;EjB61DR;AACF;Aex8DI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjBy2DN;EiBt2DM;IACE,SAAA;EjBw2DR;AACF;AiBl3DI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AjBm3DR;AiBh3DQ;EACE,SAAA;AjBk3DV;;AmB/hEA;EACE,cAAA;EACA,WAAA;EACA,mCf2esC;Ee1etC,yBAAA;Ed0KI,iBAAA;EcvKJ,gBfmR4B;EelR5B,gBfuR4B;EetR5B,cfDS;EeET,sBfTS;EeUT,4BAAA;EACA,yBAAA;ERAE,sBAAA;ESFE,wEDQJ;AnB6hEF;AoBjiEM;EDdN;ICeQ,gBAAA;EpBoiEN;AACF;AmB/hEE;EACE,6BAAA;EACA,SAAA;AnBiiEJ;AqBjjEE;EACE,cAAA;EACA,sBjBRO;EiBSP,qCjBsdoC;EiBrdpC,UAAA;EAKE,+CjBqXwB;AJ0rD9B;AmBjiEE;EACE,cfxBO;Ee0BP,UAAA;AnBkiEJ;AmBriEE;EACE,cfxBO;Ee0BP,UAAA;AnBkiEJ;AmB1hEE;EAEE,yBfxCO;Ee0CP,UAAA;AnB0hEJ;;AmBlhEE;;;;EACE,wBAAA;KAAA,qBAAA;UAAA,gBAAA;AnBwhEJ;;AmBlhEE;EACE,kBAAA;EACA,0BAAA;AnBqhEJ;AmBlhEE;EAME,cf/DO;EegEP,sBfvEO;AJslEX;;AmB1gEA;;EAEE,cAAA;EACA,WAAA;AnB6gEF;;AmBngEA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EdiEE,kBAAA;Ec/DF,gBfgM4B;AJs0D9B;;AmBngEA;EACE,+BAAA;EACA,kCAAA;Ed0EI,mBAAA;EcxEJ,gBf6H4B;AJy4D9B;;AmBngEA;EACE,gCAAA;EACA,mCAAA;EdmEI,oBAAA;EcjEJ,gBfuH4B;AJ+4D9B;;AmB7/DA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EdoDI,iBAAA;EclDJ,gBfmK4B;EelK5B,cfnHS;EeoHT,6BAAA;EACA,yBAAA;EACA,mBAAA;AnBggEF;AmB9/DE;EAEE,gBAAA;EACA,eAAA;AnB+/DJ;;AmBn/DA;EACE,kCf6VsC;Ee5VtC,uBAAA;Ed2BI,oBAAA;EczBJ,gBf+E4B;EOxN1B,qBAAA;AXgoEJ;;AmBn/DA;EACE,gCfsVsC;EerVtC,oBAAA;EdmBI,mBAAA;EcjBJ,gBfsE4B;EOvN1B,qBAAA;AXwoEJ;;AmBj/DE;EAEE,YAAA;AnBm/DJ;;AmB/+DA;EACE,YAAA;AnBk/DF;;AmB1+DA;EACE,mBf2UsC;AJkqDxC;;AmB1+DA;EACE,cAAA;EACA,mBf4TsC;AJirDxC;;AmBr+DA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AnBw+DF;AmBt+DE;;EAEE,kBAAA;EACA,iBAAA;AnBw+DJ;;AmB/9DA;EACE,kBAAA;EACA,cAAA;EACA,qBfiSsC;AJisDxC;;AmB/9DA;EACE,kBAAA;EACA,kBf6RsC;Ee5RtC,qBAAA;AnBk+DF;AmB/9DE;EAEE,cfzNO;AJyrEX;;AmB59DA;EACE,gBAAA;AnB+9DF;;AmB59DA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBf8QsC;AJitDxC;AmB59DE;EACE,gBAAA;EACA,aAAA;EACA,uBfyQoC;EexQpC,cAAA;AnB89DJ;;AqB3qEE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;ECtVpC,kBAAA;EgBnHA,cFqNqC;AnBy9DzC;;AqB3qEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,oBAAA;EgBtHF,gBjBuO0B;EiBtO1B,WAAA;EACA,yCAAA;EV9CA,sBAAA;AX6tEJ;AqB1qEI;EAEE,SAAA;ArB2qEN;;AqBtqEI;;;;EAEE,cAAA;ArB2qEN;;AqBztEI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;ArBuqER;AqBpqEM;EACE,qBFuKiC;EEtKjC,iDAAA;ArBsqER;;AqBtuEI;EAyEI,8BAAA;EACA,wCAAA;ArBiqER;;AqB3uEI;EAmFI,oCjB6XgC;EiB5XhC,kFAAA;ArB4pER;;AqBhvEI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,wNAAA;ArBupER;AqBppEM;EACE,qBFmIiC;EElIjC,iDAAA;ArBspER;;AqB/oEM;EACE,cF0HiC;AnBwhEzC;AqB/oEM;;;EAEE,cAAA;ArBkpER;;AqB3oEM;EACE,cF6GiC;AnBiiEzC;AqB5oEQ;EACE,qBF0G+B;AnBoiEzC;AqBzoEQ;EACE,iEAAA;EC5JN,qED6J2B;ArB2oE/B;AqBtoEQ;EACE,iDAAA;ArBwoEV;AqBroEQ;EACE,qBFyF+B;AnB8iEzC;;AqB9nEM;EACE,qBF+EiC;AnBkjEzC;AqB7nEQ;EACE,qBF0E+B;EEzE/B,iDAAA;ArB+nEV;;AqBhxEE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;ECtVpC,kBAAA;EgBnHA,cFqNqC;AnB8jEzC;;AqBhxEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,oBAAA;EgBtHF,gBjBuO0B;EiBtO1B,WAAA;EACA,qCAAA;EV9CA,sBAAA;AXk0EJ;AqB/wEI;EAEE,SAAA;ArBgxEN;;AqB3wEI;;;;EAEE,cAAA;ArBgxEN;;AqB9zEI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;ArB4wER;AqBzwEM;EACE,qBFuKiC;EEtKjC,6CAAA;ArB2wER;;AqB30EI;EAyEI,8BAAA;EACA,wCAAA;ArBswER;;AqBh1EI;EAmFI,oCjB6XgC;EiB5XhC,kFAAA;ArBiwER;;AqBr1EI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,wNAAA;ArB4vER;AqBzvEM;EACE,qBFmIiC;EElIjC,6CAAA;ArB2vER;;AqBpvEM;EACE,cF0HiC;AnB6nEzC;AqBpvEM;;;EAEE,cAAA;ArBuvER;;AqBhvEM;EACE,cF6GiC;AnBsoEzC;AqBjvEQ;EACE,qBF0G+B;AnByoEzC;AqB9uEQ;EACE,qBAAA;EC5JN,yBD6J2B;ArBgvE/B;AqB3uEQ;EACE,6CAAA;ArB6uEV;AqB1uEQ;EACE,qBFyF+B;AnBmpEzC;;AqBnuEM;EACE,qBF+EiC;AnBupEzC;AqBluEQ;EACE,qBF0E+B;EEzE/B,6CAAA;ArBouEV;;AmB/oEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AnBkpEF;AmB7oEE;EACE,WAAA;AnB+oEJ;Ae92EI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EnB6oEJ;EmBzoEE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EnB2oEJ;EmBvoEE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EnByoEJ;EmBroEE;IACE,qBAAA;EnBuoEJ;EmBpoEE;;IAEE,WAAA;EnBsoEJ;EmBjoEE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EnBmoEJ;EmBjoEE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBfgLkC;Ie/KlC,cAAA;EnBmoEJ;EmBhoEE;IACE,mBAAA;IACA,uBAAA;EnBkoEJ;EmBhoEE;IACE,gBAAA;EnBkoEJ;AACF;;AuBp9EA;EACE,qBAAA;EAEA,gBnBuR4B;EmBtR5B,cnBMS;EmBLT,kBAAA;EAGA,sBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,yBAAA;EnB4EI,iBAAA;EmB1EJ,gBpB2L4B;EOnR1B,sBAAA;ESFE,qIGGJ;AvBu9EF;AoBt9EM;EGdN;IHeQ,gBAAA;EpBy9EN;AACF;AMn+EE;EiBUE,cnBNO;EmBOP,qBAAA;AvB49EJ;AuBz9EE;EAEE,UAAA;EACA,+CnB8W0B;AJ4mE9B;AuBt9EE;EAEE,anBkZ0B;AJqkE9B;AuBn9EE;EACE,eAAA;AvBq9EJ;AuBv8EA;;EAEE,oBAAA;AvBy8EF;;AuBh8EE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJ27Ef;AM3/EE;EkBAE,WAAA;EFNA,2CED2D;EAS3D,8DATqG;AxBugFzG;AwB3/EE;EAEE,WAAA;EFbA,2CED2D;EAgB3D,8DAhBqG;EAqBnG,sDAAA;AxBw/EN;AwBn/EE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJ28Ef;AwB7+EE;EAGE,WAAA;EACA,kEAzC+I;EA6C/I,8DA7CyL;AxBuhF7L;AwBx+EI;EAKI,sDAAA;AxBs+ER;;AuB99EE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJy9Ef;AMzhFE;EkBAE,WAAA;EFNA,kEED2D;EAS3D,gEATqG;AxBqiFzG;AwBzhFE;EAEE,WAAA;EFbA,kEED2D;EAgB3D,gEAhBqG;EAqBnG,yDAAA;AxBshFN;AwBjhFE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJy+Ef;AwB3gFE;EAGE,WAAA;EACA,oEAzC+I;EA6C/I,8DA7CyL;AxBqjF7L;AwBtgFI;EAKI,yDAAA;AxBogFR;;AuB5/EE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJu/Ef;AMvjFE;EkBAE,WAAA;EFNA,mEED2D;EAS3D,+DATqG;AxBmkFzG;AwBvjFE;EAEE,WAAA;EFbA,mEED2D;EAgB3D,+DAhBqG;EAqBnG,wDAAA;AxBojFN;AwB/iFE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJugFf;AwBziFE;EAGE,WAAA;EACA,mEAzC+I;EA6C/I,+DA7CyL;AxBmlF7L;AwBpiFI;EAKI,wDAAA;AxBkiFR;;AuB1hFE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJqhFf;AMrlFE;EkBAE,cAAA;EFNA,gDED2D;EAS3D,sCATqG;AxBimFzG;AwBrlFE;EAEE,cAAA;EFbA,gDED2D;EAgB3D,sCAhBqG;EAqBnG,0DAAA;AxBklFN;AwB7kFE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJqiFf;AwBvkFE;EAGE,cAAA;EACA,0CAzC+I;EA6C/I,4CA7CyL;AxBinF7L;AwBlkFI;EAKI,0DAAA;AxBgkFR;;AuBxjFE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJmjFf;AMnnFE;EkBAE,cAAA;EFNA,0CED2D;EAS3D,iCATqG;AxB+nFzG;AwBnnFE;EAEE,cAAA;EFbA,0CED2D;EAgB3D,iCAhBqG;EAqBnG,sDAAA;AxBgnFN;AwB3mFE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJmkFf;AwBrmFE;EAGE,cAAA;EACA,qCAzC+I;EA6C/I,sCA7CyL;AxB+oF7L;AwBhmFI;EAKI,sDAAA;AxB8lFR;;AuBtlFE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJilFf;AMjpFE;EkBAE,WAAA;EFNA,kCED2D;EAS3D,qBATqG;AxB6pFzG;AwBjpFE;EAEE,WAAA;EFbA,kCED2D;EAgB3D,qBAhBqG;EAqBnG,wDAAA;AxB8oFN;AwBzoFE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJimFf;AwBnoFE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,8BA7CyL;AxB6qF7L;AwB9nFI;EAKI,wDAAA;AxB4nFR;;AuBpnFE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJ+mFf;AM/qFE;EkBAE,cAAA;EFNA,kDED2D;EAS3D,wCATqG;AxB2rFzG;AwB/qFE;EAEE,cAAA;EFbA,kDED2D;EAgB3D,wCAhBqG;EAqBnG,yDAAA;AxB4qFN;AwBvqFE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJ+nFf;AwBjqFE;EAGE,cAAA;EACA,4CAzC+I;EA6C/I,8CA7CyL;AxB2sF7L;AwB5pFI;EAKI,yDAAA;AxB0pFR;;AuBlpFE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AJ6oFf;AM7sFE;EkBAE,WAAA;EFNA,2DED2D;EAS3D,qDATqG;AxBytFzG;AwB7sFE;EAEE,WAAA;EFbA,2DED2D;EAgB3D,qDAhBqG;EAqBnG,uDAAA;AxB0sFN;AwBrsFE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AJ6pFf;AwB/rFE;EAGE,WAAA;EACA,yDAzC+I;EA6C/I,uDA7CyL;AxByuF7L;AwB1rFI;EAKI,uDAAA;AxBwrFR;;AuB1qFE;ECPA,cpBYa;EoBXb,qBpBWa;AJ0qFf;AM1uFE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJ+qFf;AwBlrFE;EAEE,8CAAA;AxBmrFJ;AwBhrFE;EAEE,cpBJW;EoBKX,6BAAA;AxBirFJ;AwB9qFE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJ2rFf;AwB5qFI;EAKI,8CAAA;AxB0qFR;;AuBnsFE;ECPA,cpBYa;EoBXb,qBpBWa;AJmsFf;AMnwFE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJwsFf;AwB3sFE;EAEE,iDAAA;AxB4sFJ;AwBzsFE;EAEE,cpBJW;EoBKX,6BAAA;AxB0sFJ;AwBvsFE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJotFf;AwBrsFI;EAKI,iDAAA;AxBmsFR;;AuB5tFE;ECPA,cpBYa;EoBXb,qBpBWa;AJ4tFf;AM5xFE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJiuFf;AwBpuFE;EAEE,gDAAA;AxBquFJ;AwBluFE;EAEE,cpBJW;EoBKX,6BAAA;AxBmuFJ;AwBhuFE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJ6uFf;AwB9tFI;EAKI,gDAAA;AxB4tFR;;AuBrvFE;ECPA,cpBYa;EoBXb,qBpBWa;AJqvFf;AMrzFE;EkBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJ0vFf;AwB7vFE;EAEE,iDAAA;AxB8vFJ;AwB3vFE;EAEE,cpBJW;EoBKX,6BAAA;AxB4vFJ;AwBzvFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJswFf;AwBvvFI;EAKI,iDAAA;AxBqvFR;;AuB9wFE;ECPA,cpBYa;EoBXb,qBpBWa;AJ8wFf;AM90FE;EkBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJmxFf;AwBtxFE;EAEE,+CAAA;AxBuxFJ;AwBpxFE;EAEE,cpBJW;EoBKX,6BAAA;AxBqxFJ;AwBlxFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJ+xFf;AwBhxFI;EAKI,+CAAA;AxB8wFR;;AuBvyFE;ECPA,cpBYa;EoBXb,qBpBWa;AJuyFf;AMv2FE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJ4yFf;AwB/yFE;EAEE,4CAAA;AxBgzFJ;AwB7yFE;EAEE,cpBJW;EoBKX,6BAAA;AxB8yFJ;AwB3yFE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJwzFf;AwBzyFI;EAKI,4CAAA;AxBuyFR;;AuBh0FE;ECPA,cpBYa;EoBXb,qBpBWa;AJg0Ff;AMh4FE;EkBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJq0Ff;AwBx0FE;EAEE,iDAAA;AxBy0FJ;AwBt0FE;EAEE,cpBJW;EoBKX,6BAAA;AxBu0FJ;AwBp0FE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJi1Ff;AwBl0FI;EAKI,iDAAA;AxBg0FR;;AuBz1FE;ECPA,cpBYa;EoBXb,qBpBWa;AJy1Ff;AMz5FE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AJ81Ff;AwBj2FE;EAEE,8CAAA;AxBk2FJ;AwB/1FE;EAEE,cpBJW;EoBKX,6BAAA;AxBg2FJ;AwB71FE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;AJ02Ff;AwB31FI;EAKI,8CAAA;AxBy1FR;;AuBv2FA;EACE,gBnB6M4B;EmB5M5B,cnB2FwC;EmB1FxC,qBnB2FwC;AJ+wF1C;AMn7FE;EiB4EE,8BnByFsC;EmBxFtC,0BnByFsC;AJixF1C;AuBv2FE;EAEE,0BnBoFsC;AJoxF1C;AuBr2FE;EAEE,cnBtFO;EmBuFP,oBAAA;AvBs2FJ;;AuB31FA;ECPE,oBAAA;EnB4EI,mBAAA;EmB1EJ,gBpB+H4B;EOvN1B,qBAAA;AX+7FJ;;AuB91FA;ECXE,uBAAA;EnB4EI,oBAAA;EmB1EJ,gBpBgI4B;EOxN1B,qBAAA;AXs8FJ;;AuB51FA;EACE,cAAA;EACA,WAAA;AvB+1FF;AuB51FE;EACE,kBnBwT0B;AJsiF9B;;AuBt1FE;;;EACE,WAAA;AvB21FJ;;AyBt+FA;ELgBM,gCKfJ;AzBy+FF;AoBt9FM;EKpBN;ILqBQ,gBAAA;EpBy9FN;AACF;AyB5+FE;EACE,UAAA;AzB8+FJ;;AyBz+FE;EACE,aAAA;AzB4+FJ;;AyBx+FA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;AzB2+FF;AoBz+FM;EKNN;ILOQ,gBAAA;EpB4+FN;AACF;AyB9+FE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;AzBg/FJ;AoBn/FM;EKAJ;ILCM,gBAAA;EpBs/FN;AACF;;A0B3gGA;;;;EAIE,kBAAA;A1B8gGF;;A0B3gGA;EACE,mBAAA;A1B8gGF;A2B1/FI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A3B6hGF;A2Bx+FI;EACE,cAAA;A3B0+FN;;A0BphGA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBypBkC;EsBxpBlC,aAAA;EACA,WAAA;EACA,gBtBiuBkC;EsBhuBlC,iBAAA;EACA,oBAAA;ErB2JI,iBAAA;EqBzJJ,ctBXS;EsBYT,gBAAA;EACA,gBAAA;EACA,sBtBvBS;EsBwBT,4BAAA;EACA,qCAAA;EfdE,sBAAA;AXsiGJ;;A0B/gGI;EACE,WAAA;EACA,OAAA;A1BkhGN;;A0B/gGI;EACE,QAAA;EACA,UAAA;A1BkhGN;;AetgGI;EWnBA;IACE,WAAA;IACA,OAAA;E1B6hGJ;E0B1hGE;IACE,QAAA;IACA,UAAA;E1B4hGJ;AACF;AejhGI;EWnBA;IACE,WAAA;IACA,OAAA;E1BuiGJ;E0BpiGE;IACE,QAAA;IACA,UAAA;E1BsiGJ;AACF;Ae3hGI;EWnBA;IACE,WAAA;IACA,OAAA;E1BijGJ;E0B9iGE;IACE,QAAA;IACA,UAAA;E1BgjGJ;AACF;AeriGI;EWnBA;IACE,WAAA;IACA,OAAA;E1B2jGJ;E0BxjGE;IACE,QAAA;IACA,UAAA;E1B0jGJ;AACF;A0BnjGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtB+rBgC;AJs3EpC;A2BplGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A3BgnGF;A2BlkGI;EACE,cAAA;A3BokGN;;A0BzjGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBtBirBgC;AJ24EpC;A2BzmGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A3B8nGF;A2BvlGI;EACE,cAAA;A3BylGN;A0BpkGI;EACE,iBAAA;A1BskGN;;A0BhkGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBtBgqBgC;AJm6EpC;A2BjoGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;A3BmoGN;A2BxnGM;EACE,aAAA;A3B0nGR;A2BvnGM;EACE,qBAAA;EACA,qBvB4MsB;EuB3MtB,uBvB0MsB;EuBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A3BwpGF;A2BvnGI;EACE,cAAA;A3BynGN;A0BnlGI;EACE,iBAAA;A1BqlGN;;A0B7kGE;EAIE,WAAA;EACA,YAAA;A1B6kGJ;;A0BxkGA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A5B0rGF;;A0BxkGA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBtBiK4B;EsBhK5B,ctBhHS;EsBiHT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A1B0kGF;AM/rGE;EoBoIE,+CtBonBgC;EsBnnBhC,qBAAA;EJ/IA,yBlBGO;AJ2sGX;A0B3jGE;EAEE,WtBpJO;EsBqJP,qBAAA;EJtJA,yBlBoP0B;AJ+9F9B;A0BzjGE;EAEE,ctBtJO;EsBuJP,oBAAA;EACA,6BAAA;A1B0jGJ;;A0BljGA;EACE,cAAA;A1BqjGF;;A0BjjGA;EACE,cAAA;EACA,sBtBimBkC;EsBhmBlC,gBAAA;ErBAI,oBAAA;EqBEJ,ctBzKS;EsB0KT,mBAAA;A1BojGF;;A0BhjGA;EACE,cAAA;EACA,uBAAA;EACA,ctB9KS;AJiuGX;;A6B9uGA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A7BivGF;A6B/uGE;;EACE,kBAAA;EACA,cAAA;A7BkvGJ;AMjvGE;;EuBII,UAAA;A7BivGN;A6B/uGI;;;;EAGE,UAAA;A7BkvGN;;A6B5uGA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A7B+uGF;A6B7uGE;EACE,WAAA;A7B+uGJ;;A6BzuGE;;EAEE,iBAAA;A7B4uGJ;A6BxuGE;;ElBXE,0BAAA;EACA,6BAAA;AXuvGJ;A6BxuGE;;ElBFE,yBAAA;EACA,4BAAA;AX8uGJ;;A6B3tGA;EACE,wBAAA;EACA,uBAAA;A7B8tGF;A6B5tGE;EAGE,cAAA;A7B4tGJ;A6BztGE;EACE,eAAA;A7B2tGJ;;A6BvtGA;EACE,uBAAA;EACA,sBAAA;A7B0tGF;;A6BvtGA;EACE,sBAAA;EACA,qBAAA;A7B0tGF;;A6BtsGA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A7BysGF;A6BvsGE;;EAEE,WAAA;A7BysGJ;A6BtsGE;;EAEE,gBAAA;A7BwsGJ;A6BpsGE;;ElBrFE,6BAAA;EACA,4BAAA;AX6xGJ;A6BpsGE;;ElBxGE,yBAAA;EACA,0BAAA;AXgzGJ;;A6BrrGE;;EAEE,gBAAA;A7BwrGJ;A6BtrGI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A7B0rGN;;A8Bn1GA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9Bs1GF;A8Bp1GE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;A9Bs1GJ;A8Bp1GI;;;;;;;;;;;;EAGE,iBAAA;A9B+1GN;A8B11GE;;;EAGE,UAAA;A9B41GJ;A8Bx1GE;EACE,UAAA;A9B01GJ;A8Br1GI;;EnBIA,yBAAA;EACA,4BAAA;AXq1GJ;A8Br1GE;EACE,aAAA;EACA,mBAAA;A9Bu1GJ;A8Br1GI;EnBnBA,0BAAA;EACA,6BAAA;AX22GJ;A8Bv1GI;EnBPA,yBAAA;EACA,4BAAA;AXi2GJ;A8Bv1GI;;;;EnBzBA,0BAAA;EACA,6BAAA;AXs3GJ;A8Br1GI;;;;EnBlCA,0BAAA;EACA,6BAAA;AX63GJ;;A8B50GA;;EAEE,aAAA;A9B+0GF;A8B10GE;;EACE,kBAAA;EACA,UAAA;A9B60GJ;A8B30GI;;EACE,UAAA;A9B80GN;A8B10GE;;;;;;;;EAIE,iBAAA;A9Bg1GJ;;A8B50GA;EAAuB,kBAAA;A9Bg1GvB;;A8B/0GA;EAAsB,iBAAA;A9Bm1GtB;;A8B30GA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EzB2DI,iBAAA;EyBzDJ,gB1BqK4B;E0BpK5B,gB1ByK4B;E0BxK5B,c1B/GS;E0BgHT,kBAAA;EACA,mBAAA;EACA,yB1BvHS;E0BwHT,yBAAA;EnB/GE,sBAAA;AX87GJ;A8B30GE;;EAEE,aAAA;A9B60GJ;;A8Bn0GA;;EAEE,gC1BmWsC;AJm+FxC;;A8Bn0GA;;;;;;EAME,oBAAA;EzBwBI,mBAAA;EyBtBJ,gB1B2E4B;EOvN1B,qBAAA;AXm9GJ;;A8Bn0GA;;EAEE,kC1BiVsC;AJq/FxC;;A8Bn0GA;;;;;;EAME,uBAAA;EzBOI,oBAAA;EyBLJ,gB1B2D4B;EOxN1B,qBAAA;AXo+GJ;;A8Bn0GA;;EAEE,sBAAA;A9Bs0GF;;A8B3zGA;;;;;;;;EnB9JI,0BAAA;EACA,6BAAA;AXo+GJ;;A8B5zGA;;;;;;EnB3JI,yBAAA;EACA,4BAAA;AXg+GJ;;A+BxgHA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,iCAAA;UAAA,yBAAA;A/B2gHF;;A+BxgHA;EACE,oBAAA;EACA,kB3ByfsC;AJkhGxC;;A+BxgHA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,W3BqfsC;E2BpftC,gBAAA;EACA,UAAA;A/B2gHF;A+BzgHE;EACE,W3BzBO;E2B0BP,qB3ByN0B;EkBpP1B,yBlBoP0B;AJmzG9B;A+BvgHE;EAKI,+C3BgWwB;AJqqG9B;A+BjgHE;EACE,qC3BsboC;AJ6kGxC;A+BhgHE;EACE,W3B7CO;E2B8CP,qE3Bkf4C;E2Bjf5C,iE3Bif4C;AJihGhD;A+B3/GI;EACE,c3BjDK;AJ8iHX;A+B3/GM;EACE,yB3BxDG;AJqjHX;;A+Bn/GA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;A/Bq/GF;A+Bj/GE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,W3BwboC;E2BvbpC,Y3BuboC;E2BtbpC,oBAAA;EACA,WAAA;EACA,sB3BrFO;E2BsFP,yBAAA;A/Bm/GJ;A+B9+GE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,W3ByaoC;E2BxapC,Y3BwaoC;E2BvapC,WAAA;EACA,iCAAA;A/Bg/GJ;;A+Bt+GE;EpBlGE,sBAAA;AX4kHJ;A+Br+GI;EACE,yDAAA;A/Bu+GN;A+Bl+GI;EACE,qB3B0HwB;EkBpP1B,yBlBoP0B;AJ22G9B;A+Bj+GI;EACE,yDAAA;A/Bm+GN;A+B99GI;ETpIA,uClByhB4C;AJ4kGhD;A+B99GI;ETvIA,uClByhB4C;AJ+kGhD;;A+Bt9GE;EAEE,kB3B0Z4C;AJ8jGhD;A+Bp9GI;EACE,yDAAA;A/Bs9GN;A+Bj9GI;ET9JA,uClByhB4C;AJylGhD;;A+Bz8GA;EACE,qBAAA;A/B48GF;A+Bz8GI;EACE,cAAA;EACA,c3BkY0C;E2BjY1C,mBAAA;EAEA,qB3BgY0C;AJ0kGhD;A+Bv8GI;EACE,yBAAA;EACA,0BAAA;EACA,uB3B2X0C;E2B1X1C,wB3B0X0C;E2BzX1C,yB3BpLK;E2BsLL,qB3BsX0C;EgBxiB1C,yIWmLA;A/Bw8GN;AoBvnHM;EWuKF;IXtKI,gBAAA;EpB0nHN;AACF;A+Bx8GI;EACE,sB3BlMK;E2BmML,8BAAA;A/B08GN;A+Br8GI;ETzMA,uClByhB4C;AJwnGhD;;A+B37GA;EACE,qBAAA;EACA,WAAA;EACA,mC3BqRsC;E2BpRtC,0CAAA;E1B5CI,iBAAA;E0B+CJ,gB3B6D4B;E2B5D5B,gB3BiE4B;E2BhE5B,c3BvNS;E2BwNT,sBAAA;EACA,gGAAA;EACA,yBAAA;EpBtNE,sBAAA;EoByNF,wBAAA;KAAA,qBAAA;UAAA,gBAAA;A/B47GF;A+B17GE;EACE,qC3BwPoC;E2BvPpC,UAAA;EAKE,+C3BmW8B;AJqlGpC;A+Br7GI;EAME,c3B/OK;E2BgPL,sB3BvPK;AJyqHX;A+B96GE;EAEE,YAAA;EACA,sB3B+H0B;E2B9H1B,sBAAA;A/B+6GJ;A+B56GE;EACE,c3B7PO;E2B8PP,yB3BlQO;AJgrHX;A+B16GE;EACE,aAAA;A/B46GJ;A+Bx6GE;EACE,kBAAA;EACA,0BAAA;A/B06GJ;;A+Bt6GA;EACE,kC3B0NsC;E2BzNtC,oB3BiH4B;E2BhH5B,uB3BgH4B;E2B/G5B,oB3BgH4B;EC1NxB,oBAAA;ALohHN;;A+Bt6GA;EACE,gC3BmNsC;E2BlNtC,mB3B8G4B;E2B7G5B,sB3B6G4B;E2B5G5B,kB3B6G4B;EC/NxB,mBAAA;AL4hHN;;A+Bj6GA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC3BiMsC;E2BhMtC,gBAAA;A/Bo6GF;;A+Bj6GA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC3ByLsC;E2BxLtC,SAAA;EACA,gBAAA;EACA,UAAA;A/Bo6GF;A+Bl6GE;EACE,qC3BqKoC;E2BpKpC,+C3ByE0B;AJ21G9B;A+Bh6GE;EAEE,yB3B/TO;AJguHX;A+B75GI;EACE,iB3B2Ta;AJomGnB;A+B35GE;EACE,0BAAA;A/B65GJ;;A+Bz5GA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC3BwJsC;E2BvJtC,yBAAA;EACA,gBAAA;EAEA,gB3BhE4B;E2BiE5B,gB3B5D4B;E2B6D5B,c3BpVS;E2BqVT,sB3B5VS;E2B6VT,yBAAA;EpBlVE,sBAAA;AX8uHJ;A+Bx5GE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B3BiIoC;E2BhIpC,yBAAA;EACA,gB3B5E0B;E2B6E1B,c3BpWO;E2BqWP,iBAAA;ET7WA,yBlBGO;E2B4WP,oBAAA;EpBnWA,kCAAA;AX8vHJ;;A+Bh5GA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;A/Bm5GF;A+Bj5GE;EACE,UAAA;A/Bm5GJ;A+B/4GI;EAA0B,+D3BoOe;AJ8qG7C;A+Bj5GI;EAA0B,+D3BmOe;AJirG7C;A+Bn5GI;EAA0B,+D3BkOe;AJorG7C;A+Bn5GE;EACE,SAAA;A/Bq5GJ;A+Bl5GE;EACE,W3BoNyC;E2BnNzC,Y3BmNyC;E2BlNzC,oBAAA;ETlZA,yBlBoP0B;E2BgK1B,S3BmNyC;EO3lBzC,mBAAA;ESFE,oHW6YF;EX7YE,4GW6YF;EACA,wBAAA;UAAA,gBAAA;A/Bm5GJ;AoB7xHM;EWiYJ;IXhYM,wBAAA;IAAA,gBAAA;EpBgyHN;AACF;A+Bt5GI;ET1ZA,qElB4mByC;AJusG7C;A+Bp5GE;EACE,W3B6LgC;E2B5LhC,c3B6LgC;E2B5LhC,kBAAA;EACA,e3B4LgC;E2B3LhC,yB3BhaO;E2BiaP,yBAAA;EpBzZA,mBAAA;AXgzHJ;A+Bl5GE;EACE,W3ByLyC;E2BxLzC,Y3BwLyC;EkBpmBzC,yBlBoP0B;E2B0L1B,S3ByLyC;EO3lBzC,mBAAA;ESFE,iHWuaF;EXvaE,4GWuaF;EACA,qBAAA;OAAA,gBAAA;A/Bm5GJ;AoBvzHM;EW4ZJ;IX3ZM,qBAAA;IAAA,gBAAA;EpB0zHN;AACF;A+Bt5GI;ETpbA,qElB4mByC;AJiuG7C;A+Bp5GE;EACE,W3BmKgC;E2BlKhC,c3BmKgC;E2BlKhC,kBAAA;EACA,e3BkKgC;E2BjKhC,yB3B1bO;E2B2bP,yBAAA;EpBnbA,mBAAA;AX00HJ;A+Bl5GE;EACE,W3B+JyC;E2B9JzC,Y3B8JyC;E2B7JzC,aAAA;EACA,oB3BrE0B;E2BsE1B,mB3BtE0B;EkBnY1B,yBlBoP0B;E2BuN1B,S3B4JyC;EO3lBzC,mBAAA;ESFE,gHWocF;EXpcE,4GWocF;EACA,gBAAA;A/Bm5GJ;AoBp1HM;EWsbJ;IXrbM,oBAAA;IAAA,gBAAA;EpBu1HN;AACF;A+Bt5GI;ETjdA,qElB4mByC;AJ8vG7C;A+Bp5GE;EACE,W3BsIgC;E2BrIhC,c3BsIgC;E2BrIhC,kBAAA;EACA,e3BqIgC;E2BpIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;A/Bs5GJ;A+Bl5GE;EACE,yB3B9dO;EOQP,mBAAA;AX22HJ;A+Bj5GE;EACE,kBAAA;EACA,yB3BpeO;EOQP,mBAAA;AXg3HJ;A+B/4GI;EACE,yB3BxeK;AJy3HX;A+B94GI;EACE,eAAA;A/Bg5GN;A+B74GI;EACE,yB3BhfK;AJ+3HX;A+B54GI;EACE,eAAA;A/B84GN;A+B34GI;EACE,yB3BxfK;AJq4HX;;A+Bx4GA;;;EXzfM,4GW4fJ;A/B24GF;AoBn4HM;EWqfN;;;IXpfQ,gBAAA;EpBw4HN;AACF;;AgCz5HA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AhC45HF;;AgCz5HA;EACE,cAAA;EACA,oBAAA;AhC45HF;AM35HE;E0BGE,qBAAA;AhC25HJ;AgCv5HE;EACE,c5BXO;E4BYP,oBAAA;EACA,eAAA;AhCy5HJ;;AgCj5HA;EACE,gCAAA;AhCo5HF;AgCl5HE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;ErBbA,+BAAA;EACA,gCAAA;AXk6HJ;AM96HE;E0B6BI,kBAAA;EACA,qC5BipB8B;AJmwGpC;AgCj5HI;EACE,c5BrCK;E4BsCL,6BAAA;EACA,yBAAA;AhCm5HN;AgC/4HE;;EAEE,c5B5CO;E4B6CP,sB5BpDO;E4BqDP,kC5BsoBgC;AJ2wGpC;AgC94HE;EAEE,gBAAA;ErBtCA,yBAAA;EACA,0BAAA;AXs7HJ;;AgCr4HE;EACE,gBAAA;EACA,SAAA;ErB7DA,sBAAA;AXs8HJ;AgCr4HE;;EAEE,W5B9EO;E4B+EP,yB5BoK0B;AJmuH9B;;AgC73HE;;EAEE,cAAA;EACA,kBAAA;AhCg4HJ;;AgC33HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AhC83HJ;;AgCp3HE;EACE,aAAA;AhCu3HJ;AgCr3HE;EACE,cAAA;AhCu3HJ;;AiCh+HA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AjCm+HF;AiC/9HE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AjCs+HJ;AiCl9HA;EACE,qBAAA;EACA,uB7BkqBkC;E6BjqBlC,0B7BiqBkC;E6BhqBlC,kB7BgFO;EC6CH,mBAAA;E4B3HJ,oBAAA;EACA,mBAAA;AjCo9HF;AM9/HE;E2B6CE,qBAAA;AjCo9HJ;;AiC38HA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjC88HF;AiC58HE;EACE,gBAAA;EACA,eAAA;AjC88HJ;AiC38HE;EACE,gBAAA;EACA,WAAA;AjC68HJ;;AiCp8HA;EACE,qBAAA;EACA,mB7BylBkC;E6BxlBlC,sB7BwlBkC;AJ+2GpC;;AiC37HA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AjC47HF;;AiCx7HA;EACE,wBAAA;E5B8DI,mBAAA;E4B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EtBxGE,sBAAA;AXoiIJ;AMtiIE;E2B8GE,qBAAA;AjC27HJ;;AiCr7HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AjCw7HF;;AiCr7HA;EACE,gB7BglBkC;E6B/kBlC,gBAAA;AjCw7HF;;Ae9/HI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjCq7HR;AACF;AevhII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjC06HN;EiCx6HM;IACE,mBAAA;EjC06HR;EiCx6HQ;IACE,kBAAA;EjC06HV;EiCv6HQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EJi5GlC;EiCp6HM;;;;;;IACE,iBAAA;EjC26HR;EiC75HM;IACE,iBAAA;EjC+5HR;EiC55HM;IACE,wBAAA;IAGA,gBAAA;EjC45HR;EiCz5HM;IACE,aAAA;EjC25HR;AACF;Ae5iII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjCk+HR;AACF;AepkII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjCu9HN;EiCr9HM;IACE,mBAAA;EjCu9HR;EiCr9HQ;IACE,kBAAA;EjCu9HV;EiCp9HQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EJ87GlC;EiCj9HM;;;;;;IACE,iBAAA;EjCw9HR;EiC18HM;IACE,iBAAA;EjC48HR;EiCz8HM;IACE,wBAAA;IAGA,gBAAA;EjCy8HR;EiCt8HM;IACE,aAAA;EjCw8HR;AACF;AezlII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjC+gIR;AACF;AejnII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjCogIN;EiClgIM;IACE,mBAAA;EjCogIR;EiClgIQ;IACE,kBAAA;EjCogIV;EiCjgIQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EJ2+GlC;EiC9/HM;;;;;;IACE,iBAAA;EjCqgIR;EiCv/HM;IACE,iBAAA;EjCy/HR;EiCt/HM;IACE,wBAAA;IAGA,gBAAA;EjCs/HR;EiCn/HM;IACE,aAAA;EjCq/HR;AACF;AetoII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjC4jIR;AACF;Ae9pII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjCijIN;EiC/iIM;IACE,mBAAA;EjCijIR;EiC/iIQ;IACE,kBAAA;EjCijIV;EiC9iIQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EJwhHlC;EiC3iIM;;;;;;IACE,iBAAA;EjCkjIR;EiCpiIM;IACE,iBAAA;EjCsiIR;EiCniIM;IACE,wBAAA;IAGA,gBAAA;EjCmiIR;EiChiIM;IACE,aAAA;EjCkiIR;AACF;AiCnmII;EAoBI,qBAAA;EACA,2BAAA;AjCklIR;AiCrmIQ;;;;;;EACE,gBAAA;EACA,eAAA;AjC4mIV;AiCzlIQ;EACE,mBAAA;AjC2lIV;AiCzlIU;EACE,kBAAA;AjC2lIZ;AiCxlIU;EACE,qB7ByhBwB;E6BxhBxB,oB7BwhBwB;AJkkHpC;AiCrlIQ;;;;;;EACE,iBAAA;AjC4lIV;AiC9kIQ;EACE,iBAAA;AjCglIV;AiC7kIQ;EACE,wBAAA;EAGA,gBAAA;AjC6kIV;AiC1kIQ;EACE,aAAA;AjC4kIV;;AiC9jIE;EACE,yB7BigBgC;AJgkHpC;AMzxIE;E2B2NI,yB7B8f8B;AJmkHpC;AiC5jII;EACE,yB7Bsf8B;AJwkHpC;AM/xIE;E2BoOM,yB7Bof4B;AJ0kHpC;AiC3jIM;EACE,yB7Bkf4B;AJ2kHpC;AiCzjII;;;;EAIE,yB7Bye8B;AJklHpC;AiCvjIE;EACE,yB7BkegC;E6BjehC,gC7BsegC;AJmlHpC;AiCtjIE;EACE,yDAAA;AjCwjIJ;AiCrjIE;EACE,yB7BydgC;AJ8lHpC;AiCtjII;EACE,yB7Byd8B;AJ+lHpC;AMxzIE;E2BmQM,yB7Bsd4B;AJkmHpC;;AiChjIE;EACE,W7BrRO;AJw0IX;AM/zIE;E2B+QI,W7BxRK;AJ20IX;AiC9iII;EACE,+B7B2b8B;AJqnHpC;AMr0IE;E2BwRM,gC7Byb4B;AJunHpC;AiC7iIM;EACE,gC7Bub4B;AJwnHpC;AiC3iII;;;;EAIE,W7B7SK;AJ01IX;AiCziIE;EACE,+B7BuagC;E6BtahC,sC7B2agC;AJgoHpC;AiCxiIE;EACE,yDAAA;AjC0iIJ;AiCviIE;EACE,+B7B8ZgC;AJ2oHpC;AiCxiII;EACE,W7B7TK;AJu2IX;AM91IE;E2BuTM,W7BhUG;AJ02IX;;AkC72IA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sB9BJS;E8BKT,2BAAA;EACA,sCAAA;EvBKE,sBAAA;AX22IJ;AkC72IE;EACE,eAAA;EACA,cAAA;AlC+2IJ;AkC52IE;EACE,mBAAA;EACA,sBAAA;AlC82IJ;AkC52II;EACE,mBAAA;EvBCF,2CAAA;EACA,4CAAA;AX82IJ;AkC52II;EACE,sBAAA;EvBUF,+CAAA;EACA,8CAAA;AXq2IJ;AkCz2IE;;EAEE,aAAA;AlC22IJ;;AkCv2IA;EAGE,cAAA;EAGA,eAAA;EACA,gB9BgxBkC;AJslHpC;;AkCl2IA;EACE,sB9B0wBkC;AJ2lHpC;;AkCl2IA;EACE,qBAAA;EACA,gBAAA;AlCq2IF;;AkCl2IA;EACE,gBAAA;AlCq2IF;;AM15IE;E4B0DE,qBAAA;AlCo2IJ;AkCj2IE;EACE,oB9ByvBgC;AJ0mHpC;;AkC31IA;EACE,wBAAA;EACA,gBAAA;EAEA,qC9BkvBkC;E8BjvBlC,6CAAA;AlC61IF;AkC31IE;EvBvEE,0DAAA;AXq6IJ;;AkCz1IA;EACE,wBAAA;EAEA,qC9BuuBkC;E8BtuBlC,0CAAA;AlC21IF;AkCz1IE;EvBlFE,0DAAA;AX86IJ;;AkCl1IA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AlCq1IF;;AkCl1IA;EACE,uBAAA;EACA,sBAAA;AlCq1IF;;AkCj1IA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB9B6sBkC;EO5zBhC,kCAAA;AXo8IJ;;AkCj1IA;;;EAGE,cAAA;EACA,WAAA;AlCo1IF;;AkCj1IA;;EvBjHI,2CAAA;EACA,4CAAA;AXu8IJ;;AkCl1IA;;EvBxGI,+CAAA;EACA,8CAAA;AX+7IJ;;AkC/0IE;EACE,mB9BqrBgC;AJ6pHpC;Aej7II;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;ElCk1IF;EkCh1IE;IAEE,YAAA;IACA,kB9ByqB8B;I8BxqB9B,gBAAA;IACA,iB9BuqB8B;EJ0qHlC;AACF;;AkCr0IE;EACE,mB9BypBgC;AJ+qHpC;Aen8II;EmBuHJ;IAQI,aAAA;IACA,mBAAA;ElCw0IF;EkCr0IE;IAEE,YAAA;IACA,gBAAA;ElCs0IJ;EkCp0II;IACE,cAAA;IACA,cAAA;ElCs0IN;EkCj0IM;IvBzKJ,0BAAA;IACA,6BAAA;EX6+IF;EkCl0IQ;;IAGE,0BAAA;ElCm0IV;EkCj0IQ;;IAGE,6BAAA;ElCk0IV;EkC9zIM;IvB1KJ,yBAAA;IACA,4BAAA;EX2+IF;EkC/zIQ;;IAGE,yBAAA;ElCg0IV;EkC9zIQ;;IAGE,4BAAA;ElC+zIV;AACF;;AkClzIE;EACE,sB9B8kBgC;AJuuHpC;Ae7+II;EmBsLJ;IAMI,oB9B2lBgC;S8B3lBhC,e9B2lBgC;I8B1lBhC,wB9B2lBgC;S8B3lBhC,mB9B2lBgC;I8B1lBhC,UAAA;IACA,SAAA;ElCqzIF;EkCnzIE;IACE,qBAAA;IACA,WAAA;ElCqzIJ;AACF;;AkC5yIA;EACE,qBAAA;AlC+yIF;AkC7yIE;EACE,gBAAA;AlC+yIJ;AkC7yII;EACE,gBAAA;EvBvOF,6BAAA;EACA,4BAAA;AXuhJJ;AkC7yII;EvBzPA,yBAAA;EACA,0BAAA;AXyiJJ;AkC7yII;EvBtQA,gBAAA;EuBwQE,mBAAA;AlC+yIN;;AmCzkJA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/BqiCkC;E+BniClC,gBAAA;EACA,yB/BES;EOSP,sBAAA;AXikJJ;;AmCtkJE;EACE,oB/ByhCgC;AJgjHpC;AmCvkJI;EACE,WAAA;EACA,qB/BqhC8B;E+BphC9B,c/BNK;E+BOL,YAAA;AnCykJN;AmC/jJE;EACE,0BAAA;AnCikJJ;AmC9jJE;EACE,qBAAA;AnCgkJJ;AmC7jJE;EACE,c/B1BO;AJylJX;;AoCtmJA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,sBAAA;AX2lJJ;;AoCvmJA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBhCoxBkC;EgCnxBlC,chCmKwC;EgCjKxC,sBhCPS;EgCQT,yBAAA;ApCymJF;AoCvmJE;EACE,UAAA;EACA,8BhC8JsC;EgC7JtC,qBAAA;EACA,yBhCZO;EgCaP,qBhCZO;AJqnJX;AoCtmJE;EACE,UAAA;EACA,UhC4wBgC;EgC3wBhC,+ChC+W0B;AJyvI9B;;AoClmJI;EACE,cAAA;EzBaF,+BAAA;EACA,kCAAA;AXylJJ;AoClmJI;EzBNA,gCAAA;EACA,mCAAA;AX2mJJ;AoCjmJE;EACE,UAAA;EACA,WhCxCO;EgCyCP,yBhC0M0B;EgCzM1B,qBhCyM0B;AJ05I9B;AoChmJE;EACE,chCxCO;EgCyCP,oBAAA;EAEA,YAAA;EACA,sBhClDO;EgCmDP,qBhChDO;AJipJX;;AqCxpJE;EACE,uBAAA;EhCgLE,mBAAA;EgC9KF,gBjCmO0B;AJw7I9B;AqCtpJM;E1BqCF,8BAAA;EACA,iCAAA;AXonJJ;AqCrpJM;E1BkBF,+BAAA;EACA,kCAAA;AXsoJJ;;AqCtqJE;EACE,uBAAA;EhCgLE,oBAAA;EgC9KF,gBjCoO0B;AJq8I9B;AqCpqJM;E1BqCF,8BAAA;EACA,iCAAA;AXkoJJ;AqCnqJM;E1BkBF,+BAAA;EACA,kCAAA;AXopJJ;;AsClrJA;EACE,qBAAA;EACA,qBAAA;EjC6JE,cAAA;EiC3JF,gBlCwR4B;EkCvR5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,sBAAA;ESFE,qIkBDJ;AtCqrJF;AoBhrJM;EkBfN;IlBgBQ,gBAAA;EpBmrJN;AACF;AMzrJE;EgCGI,qBAAA;AtCyrJN;;AsCprJE;EACE,aAAA;AtCurJJ;;AsClrJA;EACE,kBAAA;EACA,SAAA;AtCqrJF;;AsC9qJA;EACE,oBlCi4BkC;EkCh4BlC,mBlCg4BkC;EOv5BhC,oBAAA;AXysJJ;;AsCzqJE;ECjDA,WAAA;EACA,yBnC0Ea;AJopJf;AMhtJE;EiCVI,WAAA;EACA,kEAAA;AvC6tJN;AuC1tJI;EAEE,UAAA;EACA,8CAAA;AvC2tJN;;AsCtrJE;ECjDA,WAAA;EACA,yBnC0Ea;AJiqJf;AM7tJE;EiCVI,WAAA;EACA,oEAAA;AvC0uJN;AuCvuJI;EAEE,UAAA;EACA,iDAAA;AvCwuJN;;AsCnsJE;ECjDA,WAAA;EACA,yBnC0Ea;AJ8qJf;AM1uJE;EiCVI,WAAA;EACA,mEAAA;AvCuvJN;AuCpvJI;EAEE,UAAA;EACA,gDAAA;AvCqvJN;;AsChtJE;ECjDA,cAAA;EACA,yBnC0Ea;AJ2rJf;AMvvJE;EiCVI,cAAA;EACA,0CAAA;AvCowJN;AuCjwJI;EAEE,UAAA;EACA,iDAAA;AvCkwJN;;AsC7tJE;ECjDA,cAAA;EACA,yBnC0Ea;AJwsJf;AMpwJE;EiCVI,cAAA;EACA,qCAAA;AvCixJN;AuC9wJI;EAEE,UAAA;EACA,+CAAA;AvC+wJN;;AsC1uJE;ECjDA,WAAA;EACA,yBnC0Ea;AJqtJf;AMjxJE;EiCVI,WAAA;EACA,yBAAA;AvC8xJN;AuC3xJI;EAEE,UAAA;EACA,4CAAA;AvC4xJN;;AsCvvJE;ECjDA,cAAA;EACA,yBnC0Ea;AJkuJf;AM9xJE;EiCVI,cAAA;EACA,4CAAA;AvC2yJN;AuCxyJI;EAEE,UAAA;EACA,iDAAA;AvCyyJN;;AsCpwJE;ECjDA,WAAA;EACA,yBnC0Ea;AJ+uJf;AM3yJE;EiCVI,WAAA;EACA,yDAAA;AvCwzJN;AuCrzJI;EAEE,UAAA;EACA,8CAAA;AvCszJN;;AwCn0JA;EACE,kBAAA;EACA,mBpCyzBkC;EoCvzBlC,yBpCKS;EOSP,qBAAA;AXwzJJ;Ae9wJI;EyB5DJ;IAQI,kBAAA;ExCs0JF;AACF;;AwCn0JA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;AXm0JJ;;AyCj1JA;EACE,kBAAA;EACA,wBAAA;EACA,mBrCy9BkC;EqCx9BlC,6BAAA;E9BUE,sBAAA;AX20JJ;;AyCh1JA;EAEE,cAAA;AzCk1JF;;AyC90JA;EACE,gBrC6Q4B;AJokJ9B;;AyCz0JA;EACE,sBAAA;AzC40JF;AyCz0JE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;AzC20JJ;;AyCj0JE;EC/CA,6BDgDqH;EnB3CnH,wCmB2CuB;EC9CzB,wCD8CqE;AzCs0JvE;A0Cl3JE;EACE,qEAAA;A1Co3JJ;A0Cj3JE;EACE,sDAAA;A1Cm3JJ;;AyC70JE;EC/CA,+BDgDqH;EnB3CnH,0CmB2CuB;EC9CzB,yCD8CqE;AzCk1JvE;A0C93JE;EACE,qEAAA;A1Cg4JJ;A0C73JE;EACE,uDAAA;A1C+3JJ;;AyCz1JE;EC/CA,+BDgDqH;EnB3CnH,0CmB2CuB;EC9CzB,yCD8CqE;AzC81JvE;A0C14JE;EACE,qEAAA;A1C44JJ;A0Cz4JE;EACE,uDAAA;A1C24JJ;;AyCr2JE;EC/CA,kCDgDqH;EnB3CnH,0CmB2CuB;EC9CzB,yCD8CqE;AzC02JvE;A0Ct5JE;EACE,6CAAA;A1Cw5JJ;A0Cr5JE;EACE,+BAAA;A1Cu5JJ;;AyCj3JE;EC/CA,+BDgDqH;EnB3CnH,wCmB2CuB;EC9CzB,sCD8CqE;AzCs3JvE;A0Cl6JE;EACE,2CAAA;A1Co6JJ;A0Cj6JE;EACE,sDAAA;A1Cm6JJ;;AyC73JE;EC/CA,uBDgDqH;EnB3CnH,sCmB2CuB;EC9CzB,uCD8CqE;AzCk4JvE;A0C96JE;EACE,qEAAA;A1Cg7JJ;A0C76JE;EACE,YAAA;A1C+6JJ;;AyCz4JE;EC/CA,+BDgDqH;EnB3CnH,wCmB2CuB;EC9CzB,wCD8CqE;AzC84JvE;A0C17JE;EACE,+CAAA;A1C47JJ;A0Cz7JE;EACE,kDAAA;A1C27JJ;;AyCr5JE;EC/CA,+BDgDqH;EnB3CnH,0CmB2CuB;EC9CzB,yCD8CqE;AzC05JvE;A0Ct8JE;EACE,6DAAA;A1Cw8JJ;A0Cr8JE;EACE,4CAAA;A1Cu8JJ;;A2C/8JE;EACE;IAAO,2BAAA;E3Cm9JT;E2Cl9JE;IAAK,wBAAA;E3Cq9JP;AACF;A2Cl9JA;EACE,aAAA;EACA,YvCk+BkC;EuCj+BlC,gBAAA;EACA,cAAA;EtCwKI,mBAAA;EsCtKJ,yBvCLS;EOSP,sBAAA;AXi9JJ;;A2Ch9JA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WvCjBS;EuCkBT,kBAAA;EACA,mBAAA;EACA,yBvCu9BkC;EgBl+B9B,2BuBYJ;A3Cm9JF;AoB39JM;EuBDN;IvBEQ,gBAAA;EpB89JN;AACF;;A2Cr9JA;ErBYE,qMAAA;EqBVA,0BAAA;A3Cw9JF;;A2Cp9JE;EACE,kDAAA;A3Cu9JJ;A2Cp9JM;EAJJ;IAKM,eAAA;E3Cu9JN;AACF;;A4ClgKA;EACE,aAAA;EACA,uBAAA;A5CqgKF;;A4ClgKA;EACE,OAAA;A5CqgKF;;A6CvgKA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,sBAAA;AXigKJ;;A6C//JA;EACE,WAAA;EACA,czCRS;EyCST,mBAAA;A7CkgKF;AMzgKE;EuCWE,UAAA;EACA,czCdO;EyCeP,qBAAA;EACA,yBzCtBO;AJuhKX;A6C9/JE;EACE,czClBO;EyCmBP,yBzC1BO;AJ0hKX;;A6Cv/JA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,sBzC3CS;EyC4CT,sCAAA;A7Cw/JF;A6Ct/JE;ElC1BE,+BAAA;EACA,gCAAA;AXmhKJ;A6Ct/JE;ElChBE,mCAAA;EACA,kCAAA;AXygKJ;A6Ct/JE;EAEE,czClDO;EyCmDP,oBAAA;EACA,sBzC1DO;AJijKX;A6Cn/JE;EACE,UAAA;EACA,WzChEO;EyCiEP,yBzCkL0B;EyCjL1B,qBzCiL0B;AJo0J9B;A6Cl/JE;EACE,mBAAA;A7Co/JJ;A6Cl/JI;EACE,gBAAA;EACA,qBzC2JwB;AJy1J9B;;A6Ct+JI;EACE,mBAAA;A7Cy+JN;A6Ct+JQ;ElC1BJ,kCAAA;EAZA,0BAAA;AXghKJ;A6Cr+JQ;ElC3CJ,gCAAA;EAYA,4BAAA;AXwgKJ;A6Cp+JQ;EACE,aAAA;A7Cs+JV;A6Cn+JQ;EACE,qBzC0HoB;EyCzHpB,oBAAA;A7Cq+JV;A6Cn+JU;EACE,iBAAA;EACA,sBzCqHkB;AJg3J9B;;AehiKI;E8BmCA;IACE,mBAAA;E7CigKJ;E6C9/JM;IlC1BJ,kCAAA;IAZA,0BAAA;EXwiKF;E6C7/JM;IlC3CJ,gCAAA;IAYA,4BAAA;EXgiKF;E6C5/JM;IACE,aAAA;E7C8/JR;E6C3/JM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E7C6/JR;E6C3/JQ;IACE,iBAAA;IACA,sBzCqHkB;EJw4J5B;AACF;AezjKI;E8BmCA;IACE,mBAAA;E7CyhKJ;E6CthKM;IlC1BJ,kCAAA;IAZA,0BAAA;EXgkKF;E6CrhKM;IlC3CJ,gCAAA;IAYA,4BAAA;EXwjKF;E6CphKM;IACE,aAAA;E7CshKR;E6CnhKM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E7CqhKR;E6CnhKQ;IACE,iBAAA;IACA,sBzCqHkB;EJg6J5B;AACF;AejlKI;E8BmCA;IACE,mBAAA;E7CijKJ;E6C9iKM;IlC1BJ,kCAAA;IAZA,0BAAA;EXwlKF;E6C7iKM;IlC3CJ,gCAAA;IAYA,4BAAA;EXglKF;E6C5iKM;IACE,aAAA;E7C8iKR;E6C3iKM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E7C6iKR;E6C3iKQ;IACE,iBAAA;IACA,sBzCqHkB;EJw7J5B;AACF;AezmKI;E8BmCA;IACE,mBAAA;E7CykKJ;E6CtkKM;IlC1BJ,kCAAA;IAZA,0BAAA;EXgnKF;E6CrkKM;IlC3CJ,gCAAA;IAYA,4BAAA;EXwmKF;E6CpkKM;IACE,aAAA;E7CskKR;E6CnkKM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E7CqkKR;E6CnkKQ;IACE,iBAAA;IACA,sBzCqHkB;EJg9J5B;AACF;A6CxjKA;ElCnHI,gBAAA;AX8qKJ;A6CxjKE;EACE,qBAAA;A7C0jKJ;A6CxjKI;EACE,sBAAA;A7C0jKN;;A8CnsKE;EACE,6BDoJsE;ECnJtE,4CDmJuC;A7CmjK3C;AM3rKE;EwCPM,6BD+IkE;EC9IlE,qEAAA;A9CqsKR;A8ClsKM;EACE,W1CPG;E0CQH,wCDyIkE;ECxIlE,oCDwIkE;A7C4jK1E;;A8CjtKE;EACE,+BDoJsE;ECnJtE,6CDmJuC;A7CikK3C;AMzsKE;EwCPM,+BD+IkE;EC9IlE,qEAAA;A9CmtKR;A8ChtKM;EACE,W1CPG;E0CQH,0CDyIkE;ECxIlE,sCDwIkE;A7C0kK1E;;A8C/tKE;EACE,+BDoJsE;ECnJtE,6CDmJuC;A7C+kK3C;AMvtKE;EwCPM,+BD+IkE;EC9IlE,qEAAA;A9CiuKR;A8C9tKM;EACE,W1CPG;E0CQH,0CDyIkE;ECxIlE,sCDwIkE;A7CwlK1E;;A8C7uKE;EACE,kCDoJsE;ECnJtE,6CDmJuC;A7C6lK3C;AMruKE;EwCPM,kCD+IkE;EC9IlE,6CAAA;A9C+uKR;A8C5uKM;EACE,W1CPG;E0CQH,6CDyIkE;ECxIlE,yCDwIkE;A7CsmK1E;;A8C3vKE;EACE,+BDoJsE;ECnJtE,0CDmJuC;A7C2mK3C;AMnvKE;EwCPM,+BD+IkE;EC9IlE,2CAAA;A9C6vKR;A8C1vKM;EACE,W1CPG;E0CQH,0CDyIkE;ECxIlE,sCDwIkE;A7ConK1E;;A8CzwKE;EACE,uBDoJsE;ECnJtE,2CDmJuC;A7CynK3C;AMjwKE;EwCPM,uBD+IkE;EC9IlE,qEAAA;A9C2wKR;A8CxwKM;EACE,W1CPG;E0CQH,kCDyIkE;ECxIlE,8BDwIkE;A7CkoK1E;;A8CvxKE;EACE,+BDoJsE;ECnJtE,4CDmJuC;A7CuoK3C;AM/wKE;EwCPM,+BD+IkE;EC9IlE,+CAAA;A9CyxKR;A8CtxKM;EACE,W1CPG;E0CQH,0CDyIkE;ECxIlE,sCDwIkE;A7CgpK1E;;A8CryKE;EACE,+BDoJsE;ECnJtE,6CDmJuC;A7CqpK3C;AM7xKE;EwCPM,+BD+IkE;EC9IlE,6DAAA;A9CuyKR;A8CpyKM;EACE,W1CPG;E0CQH,0CDyIkE;ECxIlE,sCDwIkE;A7C8pK1E;;A+CtzKA;EACE,YAAA;E1CmLI,kBAAA;E0CjLJ,gB3C8R4B;E2C7R5B,cAAA;EACA,W3CYS;E2CXT,yB3CylCkC;E2CxlClC,YAAA;A/CyzKF;AMpzKE;EyCDE,W3CMO;E2CLP,qBAAA;A/CwzKJ;AMpzKE;EyCCI,aAAA;A/CszKN;;A+C3yKA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;A/C8yKF;;A+CxyKA;EACE,oBAAA;A/C2yKF;;AgDj1KA;EAGE,iB5C24BkC;E4C14BlC,gB5C04BkC;EC1tB9B,mBAAA;E2C7KJ,2C5C44BkC;E4C34BlC,4BAAA;EACA,oCAAA;EACA,gD5C64BkC;E4C54BlC,UAAA;ErCOE,sBAAA;AX20KJ;AgD/0KE;EACE,sB5Cg4BgC;AJi9IpC;AgD90KE;EACE,UAAA;AhDg1KJ;AgD70KE;EACE,cAAA;EACA,UAAA;AhD+0KJ;AgD50KE;EACE,aAAA;AhD80KJ;;AgD10KA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c5CvBS;E4CwBT,2C5Cq3BkC;E4Cp3BlC,4BAAA;EACA,4CAAA;ErCZE,2CAAA;EACA,4CAAA;AX01KJ;;AgD30KA;EACE,gB5Cm2BkC;AJ2+IpC;;AiDp3KA;EAEE,gBAAA;AjDs3KF;AiDp3KE;EACE,kBAAA;EACA,gBAAA;AjDs3KJ;;AiDj3KA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7C4pBkC;E6C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AjDk3KF;;AiD32KA;EACE,kBAAA;EACA,WAAA;EACA,c7Ci5BkC;E6C/4BlC,oBAAA;AjD62KF;AiD12KE;E7B3BI,mC6B4BF;EACA,8B7Cu6BgC;AJq8IpC;AoBr4KM;E6BuBJ;I7BtBM,gBAAA;EpBw4KN;AACF;AiD/2KE;EACE,e7Cq6BgC;AJ48IpC;AiD72KE;EACE,sB7Ck6BgC;AJ68IpC;;AiD32KA;EACE,aAAA;EACA,6BAAA;AjD82KF;AiD52KE;EACE,8BAAA;EACA,gBAAA;AjD82KJ;AiD32KE;;EAEE,cAAA;AjD62KJ;AiD12KE;EACE,gBAAA;AjD42KJ;;AiDx2KA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AjD22KF;AiDx2KE;EACE,cAAA;EACA,0BAAA;EACA,wBAAA;EAAA,mBAAA;EACA,WAAA;AjD02KJ;AiDt2KE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AjDw2KJ;AiDt2KI;EACE,gBAAA;AjDw2KN;AiDr2KI;EACE,aAAA;AjDu2KN;;AiDj2KA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB7C3GS;E6C4GT,4BAAA;EACA,oCAAA;EtClGE,qBAAA;EsCsGF,UAAA;AjDg2KF;;AiD51KA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7CgjBkC;E6C/iBlC,YAAA;EACA,aAAA;EACA,sB7ClHS;AJi9KX;AiD51KE;EAAS,UAAA;AjD+1KX;AiD91KE;EAAS,Y7C+zByB;AJkiJpC;;AiD51KA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kB7C6zBkC;E6C5zBlC,gCAAA;EtCtHE,0CAAA;EACA,2CAAA;AXs9KJ;AiD91KE;EACE,kB7CwzBgC;E6CtzBhC,8BAAA;AjD+1KJ;;AiD11KA;EACE,gBAAA;EACA,gB7CuI4B;AJstK9B;;AiDx1KA;EACE,kBAAA;EAGA,cAAA;EACA,a7C0wBkC;AJ+kJpC;;AiDr1KA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;EtCzIE,8CAAA;EACA,6CAAA;AXk+KJ;AiDp1KE;EACE,eAAA;AjDs1KJ;;AiDj1KA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AjDo1KF;;Ae39KI;EkC6IF;IACE,gB7CuwBgC;I6CtwBhC,oBAAA;EjDk1KF;EiD/0KA;IACE,+BAAA;EjDi1KF;EiD/0KE;IACE,gCAAA;EjDi1KJ;EiD70KA;IACE,+BAAA;EjD+0KF;EiD70KE;IACE,4BAAA;IACA,wBAAA;IAAA,mBAAA;EjD+0KJ;EiDv0KA;IAAY,gB7C+uBsB;EJ2lJlC;AACF;Ael/KI;EkC2KF;;IAEE,gB7CuuBgC;EJmmJlC;AACF;Aex/KI;EkCkLF;IAAY,iB7CiuBsB;EJymJlC;AACF;AkDxjLA;EACE,kBAAA;EACA,a9CgrBkC;E8C/qBlC,cAAA;EACA,S9C61BkC;E+Cj2BlC,qN/CoR4B;E+ClR5B,kBAAA;EACA,gB/C4R4B;E+C3R5B,gB/CgS4B;E+C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,oBAAA;E6CzKJ,qBAAA;EACA,UAAA;AlDokLF;AkDlkLE;EAAS,Y9Ci1ByB;AJovJpC;AkDnkLE;EACE,kBAAA;EACA,cAAA;EACA,a9Ci1BgC;E8Ch1BhC,c9Ci1BgC;AJovJpC;AkDnkLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AlDqkLN;;AkDhkLA;EACE,iBAAA;AlDmkLF;AkDjkLE;EACE,SAAA;AlDmkLJ;AkDjkLI;EACE,MAAA;EACA,6BAAA;EACA,sB9CvBK;AJ0lLX;;AkD9jLA;EACE,iBAAA;AlDikLF;AkD/jLE;EACE,OAAA;EACA,a9CmzBgC;E8ClzBhC,c9CizBgC;AJgxJpC;AkD/jLI;EACE,QAAA;EACA,oCAAA;EACA,wB9CvCK;AJwmLX;;AkD5jLA;EACE,iBAAA;AlD+jLF;AkD7jLE;EACE,MAAA;AlD+jLJ;AkD7jLI;EACE,SAAA;EACA,6BAAA;EACA,yB9CrDK;AJonLX;;AkD1jLA;EACE,iBAAA;AlD6jLF;AkD3jLE;EACE,QAAA;EACA,a9CqxBgC;E8CpxBhC,c9CmxBgC;AJ0yJpC;AkD3jLI;EACE,OAAA;EACA,oCAAA;EACA,uB9CrEK;AJkoLX;;AkDxiLA;EACE,gB9C+uBkC;E8C9uBlC,uBAAA;EACA,W9CvGS;E8CwGT,kBAAA;EACA,sB9C/FS;EOCP,sBAAA;AX0oLJ;;AoD5pLA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,ahD8qBkC;EgD7qBlC,cAAA;EACA,gBhD+2BkC;E+Cp3BlC,qN/CoR4B;E+ClR5B,kBAAA;EACA,gB/C4R4B;E+C3R5B,gB/CgS4B;E+C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,oBAAA;E+CxKJ,qBAAA;EACA,sBhDNS;EgDOT,4BAAA;EACA,oCAAA;EzCGE,qBAAA;AXuqLJ;AoDtqLE;EACE,kBAAA;EACA,cAAA;EACA,WhD+2BgC;EgD92BhC,chD+2BgC;EgD92BhC,gBAAA;ApDwqLJ;AoDtqLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDuqLN;;AoDlqLA;EACE,qBhDg2BkC;AJq0JpC;AoDnqLE;EACE,2BAAA;ApDqqLJ;AoDnqLI;EACE,SAAA;EACA,6BAAA;EACA,qChD21B8B;AJ00JpC;AoDlqLI;EACE,WhD0LwB;EgDzLxB,6BAAA;EACA,sBhD7CK;AJitLX;;AoD/pLA;EACE,mBhD40BkC;AJs1JpC;AoDhqLE;EACE,yBAAA;EACA,ahDw0BgC;EgDv0BhC,YhDs0BgC;EgDr0BhC,gBAAA;ApDkqLJ;AoDhqLI;EACE,OAAA;EACA,oCAAA;EACA,uChDo0B8B;AJ81JpC;AoD/pLI;EACE,ShDmKwB;EgDlKxB,oCAAA;EACA,wBhDpEK;AJquLX;;AoD5pLA;EACE,kBhDqzBkC;AJ02JpC;AoD7pLE;EACE,wBAAA;ApD+pLJ;AoD7pLI;EACE,MAAA;EACA,oCAAA;EACA,wChDgzB8B;AJ+2JpC;AoD5pLI;EACE,QhD+IwB;EgD9IxB,oCAAA;EACA,yBhDxFK;AJsvLX;AoDzpLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WhD4xBgC;EgD3xBhC,oBAAA;EACA,WAAA;EACA,oDAAA;ApD2pLJ;;AoDvpLA;EACE,oBhDqxBkC;AJq4JpC;AoDxpLE;EACE,0BAAA;EACA,ahDixBgC;EgDhxBhC,YhD+wBgC;EgD9wBhC,gBAAA;ApD0pLJ;AoDxpLI;EACE,QAAA;EACA,oCAAA;EACA,sChD6wB8B;AJ64JpC;AoDvpLI;EACE,UhD4GwB;EgD3GxB,oCAAA;EACA,uBhD3HK;AJoxLX;;AoDnoLA;EACE,uBAAA;EACA,gBAAA;E/C0BI,iBAAA;E+CvBJ,6ChD+tBkC;EgD9tBlC,iDAAA;EzCnIE,0CAAA;EACA,2CAAA;AXywLJ;AoDpoLE;EACE,aAAA;ApDsoLJ;;AoDloLA;EACE,uBAAA;EACA,chDxJS;AJ6xLX;;AqDhyLA;EACE,kBAAA;ArDmyLF;;AqDhyLA;EACE,mBAAA;ArDmyLF;;AqDhyLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ArDmyLF;AsD1zLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtD4zLJ;;AqDpyLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;ArDuyLF;AoBtzLM;EiCQN;IjCPQ,gBAAA;EpByzLN;AACF;;AqDzyLA;;;EAGE,cAAA;ArD4yLF;;AqDzyLA;;EAEE,2BAAA;ArD4yLF;;AqDzyLA;;EAEE,4BAAA;ArD4yLF;;AqDnyLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;ArDsyLJ;AqDnyLE;;;EAGE,UAAA;EACA,UAAA;ArDqyLJ;AqDlyLE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;ArDoyLJ;AoB71LM;EiCqDJ;;IjCpDM,gBAAA;EpBi2LN;AACF;;AqDjyLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjDs9BmC;EiDr9BnC,UAAA;EACA,WjD3FS;EiD4FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjDi9BmC;EgBviC/B,8BiCuFJ;ArDmyLF;AoBt3LM;EiCkEN;;IjCjEQ,gBAAA;EpB03LN;AACF;AMh4LE;;;E+C2FE,WjDpGO;EiDqGP,qBAAA;EACA,UAAA;EACA,YjD08BiC;AJg2JrC;;AqDvyLA;EACE,OAAA;ArD0yLF;;AqDryLA;EACE,QAAA;ArDwyLF;;AqDjyLA;;EAEE,qBAAA;EACA,WjDm8BmC;EiDl8BnC,YjDk8BmC;EiDj8BnC,mCAAA;ArDoyLF;;AqDlyLA;EACE,yDAAA;ArDqyLF;;AqDnyLA;EACE,yDAAA;ArDsyLF;;AqD7xLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBjDy5BmC;EiDx5BnC,gBjDw5BmC;EiDv5BnC,gBAAA;ArD+xLF;AqD7xLE;EACE,uBAAA;EACA,cAAA;EACA,WjDu5BiC;EiDt5BjC,WjDu5BiC;EiDt5BjC,iBjDw5BiC;EiDv5BjC,gBjDu5BiC;EiDt5BjC,mBAAA;EACA,eAAA;EACA,sBjDnKO;EiDoKP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC/JE,6BiCgKF;ArD8xLJ;AoB17LM;EiC6IJ;IjC5IM,gBAAA;EpB67LN;AACF;AqDhyLE;EACE,UAAA;ArDkyLJ;;AqDzxLA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WjD9LS;EiD+LT,kBAAA;ArD4xLF;;AuD99LA;EACE;IAAK,yBAAA;EvDk+LL;AACF;AuDh+LA;EACE,qBAAA;EACA,WnDskCwB;EmDrkCxB,YnDqkCwB;EmDpkCxB,wBnDskCwB;EmDrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AvDi+LF;;AuD99LA;EACE,WnDgkCwB;EmD/jCxB,YnD+jCwB;EmD9jCxB,mBnDgkCwB;AJi6J1B;;AuD19LA;EACE;IACE,mBAAA;EvD69LF;EuD39LA;IACE,UAAA;IACA,eAAA;EvD69LF;AACF;AuD19LA;EACE,qBAAA;EACA,WnDsiCwB;EmDriCxB,YnDqiCwB;EmDpiCxB,wBnDsiCwB;EmDriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AvD29LF;;AuDx9LA;EACE,WnDgiCwB;EmD/hCxB,YnD+hCwB;AJ47J1B;;AuDv9LE;EACE;;IAEE,wBAAA;EvD09LJ;AACF;AwDthMA;EAAqB,mCAAA;AxDyhMrB;;AwDxhMA;EAAqB,8BAAA;AxD4hMrB;;AwD3hMA;EAAqB,iCAAA;AxD+hMrB;;AwD9hMA;EAAqB,iCAAA;AxDkiMrB;;AwDjiMA;EAAqB,sCAAA;AxDqiMrB;;AwDpiMA;EAAqB,mCAAA;AxDwiMrB;;AyD1iME;EACE,oCAAA;AzD6iMJ;;AMniME;;;EmDLI,6EAAA;AzD8iMN;;AyDpjME;EACE,oCAAA;AzDujMJ;;AM7iME;;;EmDLI,+EAAA;AzDwjMN;;AyD9jME;EACE,oCAAA;AzDikMJ;;AMvjME;;;EmDLI,8EAAA;AzDkkMN;;AyDxkME;EACE,oCAAA;AzD2kMJ;;AMjkME;;;EmDLI,qDAAA;AzD4kMN;;AyDllME;EACE,oCAAA;AzDqlMJ;;AM3kME;;;EmDLI,gDAAA;AzDslMN;;AyD5lME;EACE,oCAAA;AzD+lMJ;;AMrlME;;;EmDLI,oCAAA;AzDgmMN;;AyDtmME;EACE,oCAAA;AzDymMJ;;AM/lME;;;EmDLI,uDAAA;AzD0mMN;;AyDhnME;EACE,oCAAA;AzDmnMJ;;AMzmME;;;EmDLI,oEAAA;AzDonMN;;A0DnnMA;EACE,iCAAA;A1DsnMF;;A0DnnMA;EACE,wCAAA;A1DsnMF;;A2DjoMA;EAAkB,oCAAA;A3DqoMlB;;A2DpoMA;EAAkB,wCAAA;A3DwoMlB;;A2DvoMA;EAAkB,0CAAA;A3D2oMlB;;A2D1oMA;EAAkB,2CAAA;A3D8oMlB;;A2D7oMA;EAAkB,yCAAA;A3DipMlB;;A2D/oMA;EAAmB,oBAAA;A3DmpMnB;;A2DlpMA;EAAmB,wBAAA;A3DspMnB;;A2DrpMA;EAAmB,0BAAA;A3DypMnB;;A2DxpMA;EAAmB,2BAAA;A3D4pMnB;;A2D3pMA;EAAmB,yBAAA;A3D+pMnB;;A2D5pME;EACE,gCAAA;A3D+pMJ;;A2DhqME;EACE,gCAAA;A3DmqMJ;;A2DpqME;EACE,gCAAA;A3DuqMJ;;A2DxqME;EACE,gCAAA;A3D2qMJ;;A2D5qME;EACE,gCAAA;A3D+qMJ;;A2DhrME;EACE,gCAAA;A3DmrMJ;;A2DprME;EACE,gCAAA;A3DurMJ;;A2DxrME;EACE,gCAAA;A3D2rMJ;;A2DvrMA;EACE,6BAAA;A3D0rMF;;A2DnrMA;EACE,gCAAA;A3DsrMF;;A2DnrMA;EACE,iCAAA;A3DsrMF;;A2DnrMA;EACE,0CAAA;EACA,2CAAA;A3DsrMF;;A2DnrMA;EACE,2CAAA;EACA,8CAAA;A3DsrMF;;A2DnrMA;EACE,8CAAA;EACA,6CAAA;A3DsrMF;;A2DnrMA;EACE,0CAAA;EACA,6CAAA;A3DsrMF;;A2DnrMA;EACE,gCAAA;A3DsrMF;;A2DnrMA;EACE,6BAAA;A3DsrMF;;A2DnrMA;EACE,+BAAA;A3DsrMF;;A2DnrMA;EACE,2BAAA;A3DsrMF;;AsD9vME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDiwMJ;;A4D1vMM;EAAwB,wBAAA;A5D8vM9B;;A4D9vMM;EAAwB,0BAAA;A5DkwM9B;;A4DlwMM;EAAwB,gCAAA;A5DswM9B;;A4DtwMM;EAAwB,yBAAA;A5D0wM9B;;A4D1wMM;EAAwB,yBAAA;A5D8wM9B;;A4D9wMM;EAAwB,6BAAA;A5DkxM9B;;A4DlxMM;EAAwB,8BAAA;A5DsxM9B;;A4DtxMM;EAAwB,wBAAA;A5D0xM9B;;A4D1xMM;EAAwB,+BAAA;A5D8xM9B;;Ae7uMI;E6CjDE;IAAwB,wBAAA;E5DmyM5B;E4DnyMI;IAAwB,0BAAA;E5DsyM5B;E4DtyMI;IAAwB,gCAAA;E5DyyM5B;E4DzyMI;IAAwB,yBAAA;E5D4yM5B;E4D5yMI;IAAwB,yBAAA;E5D+yM5B;E4D/yMI;IAAwB,6BAAA;E5DkzM5B;E4DlzMI;IAAwB,8BAAA;E5DqzM5B;E4DrzMI;IAAwB,wBAAA;E5DwzM5B;E4DxzMI;IAAwB,+BAAA;E5D2zM5B;AACF;Ae3wMI;E6CjDE;IAAwB,wBAAA;E5Dg0M5B;E4Dh0MI;IAAwB,0BAAA;E5Dm0M5B;E4Dn0MI;IAAwB,gCAAA;E5Ds0M5B;E4Dt0MI;IAAwB,yBAAA;E5Dy0M5B;E4Dz0MI;IAAwB,yBAAA;E5D40M5B;E4D50MI;IAAwB,6BAAA;E5D+0M5B;E4D/0MI;IAAwB,8BAAA;E5Dk1M5B;E4Dl1MI;IAAwB,wBAAA;E5Dq1M5B;E4Dr1MI;IAAwB,+BAAA;E5Dw1M5B;AACF;AexyMI;E6CjDE;IAAwB,wBAAA;E5D61M5B;E4D71MI;IAAwB,0BAAA;E5Dg2M5B;E4Dh2MI;IAAwB,gCAAA;E5Dm2M5B;E4Dn2MI;IAAwB,yBAAA;E5Ds2M5B;E4Dt2MI;IAAwB,yBAAA;E5Dy2M5B;E4Dz2MI;IAAwB,6BAAA;E5D42M5B;E4D52MI;IAAwB,8BAAA;E5D+2M5B;E4D/2MI;IAAwB,wBAAA;E5Dk3M5B;E4Dl3MI;IAAwB,+BAAA;E5Dq3M5B;AACF;Aer0MI;E6CjDE;IAAwB,wBAAA;E5D03M5B;E4D13MI;IAAwB,0BAAA;E5D63M5B;E4D73MI;IAAwB,gCAAA;E5Dg4M5B;E4Dh4MI;IAAwB,yBAAA;E5Dm4M5B;E4Dn4MI;IAAwB,yBAAA;E5Ds4M5B;E4Dt4MI;IAAwB,6BAAA;E5Dy4M5B;E4Dz4MI;IAAwB,8BAAA;E5D44M5B;E4D54MI;IAAwB,wBAAA;E5D+4M5B;E4D/4MI;IAAwB,+BAAA;E5Dk5M5B;AACF;A4Dz4MA;EAEI;IAAqB,wBAAA;E5D24MvB;E4D34ME;IAAqB,0BAAA;E5D84MvB;E4D94ME;IAAqB,gCAAA;E5Di5MvB;E4Dj5ME;IAAqB,yBAAA;E5Do5MvB;E4Dp5ME;IAAqB,yBAAA;E5Du5MvB;E4Dv5ME;IAAqB,6BAAA;E5D05MvB;E4D15ME;IAAqB,8BAAA;E5D65MvB;E4D75ME;IAAqB,wBAAA;E5Dg6MvB;E4Dh6ME;IAAqB,+BAAA;E5Dm6MvB;AACF;A6Dz7MA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A7D27MF;A6Dz7ME;EACE,cAAA;EACA,WAAA;A7D27MJ;A6Dx7ME;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A7D07MJ;;A6Dj7MI;EACE,yBAAA;A7Do7MN;;A6Dr7MI;EACE,mBAAA;A7Dw7MN;;A6Dz7MI;EACE,gBAAA;A7D47MN;;A6D77MI;EACE,iBAAA;A7Dg8MN;;A8Dz9MI;EAAgC,8BAAA;A9D69MpC;;A8D59MI;EAAgC,iCAAA;A9Dg+MpC;;A8D/9MI;EAAgC,sCAAA;A9Dm+MpC;;A8Dl+MI;EAAgC,yCAAA;A9Ds+MpC;;A8Dp+MI;EAA8B,0BAAA;A9Dw+MlC;;A8Dv+MI;EAA8B,4BAAA;A9D2+MlC;;A8D1+MI;EAA8B,kCAAA;A9D8+MlC;;A8D7+MI;EAA8B,yBAAA;A9Di/MlC;;A8Dh/MI;EAA8B,uBAAA;A9Do/MlC;;A8Dn/MI;EAA8B,uBAAA;A9Du/MlC;;A8Dt/MI;EAA8B,yBAAA;A9D0/MlC;;A8Dz/MI;EAA8B,yBAAA;A9D6/MlC;;A8D3/MI;EAAoC,sCAAA;A9D+/MxC;;A8D9/MI;EAAoC,oCAAA;A9DkgNxC;;A8DjgNI;EAAoC,kCAAA;A9DqgNxC;;A8DpgNI;EAAoC,yCAAA;A9DwgNxC;;A8DvgNI;EAAoC,wCAAA;A9D2gNxC;;A8DzgNI;EAAiC,kCAAA;A9D6gNrC;;A8D5gNI;EAAiC,gCAAA;A9DghNrC;;A8D/gNI;EAAiC,8BAAA;A9DmhNrC;;A8DlhNI;EAAiC,gCAAA;A9DshNrC;;A8DrhNI;EAAiC,+BAAA;A9DyhNrC;;A8DvhNI;EAAkC,oCAAA;A9D2hNtC;;A8D1hNI;EAAkC,kCAAA;A9D8hNtC;;A8D7hNI;EAAkC,gCAAA;A9DiiNtC;;A8DhiNI;EAAkC,uCAAA;A9DoiNtC;;A8DniNI;EAAkC,sCAAA;A9DuiNtC;;A8DtiNI;EAAkC,iCAAA;A9D0iNtC;;A8DxiNI;EAAgC,2BAAA;A9D4iNpC;;A8D3iNI;EAAgC,iCAAA;A9D+iNpC;;A8D9iNI;EAAgC,+BAAA;A9DkjNpC;;A8DjjNI;EAAgC,6BAAA;A9DqjNpC;;A8DpjNI;EAAgC,+BAAA;A9DwjNpC;;A8DvjNI;EAAgC,8BAAA;A9D2jNpC;;Ae/iNI;E+ClDA;IAAgC,8BAAA;E9DsmNlC;E8DrmNE;IAAgC,iCAAA;E9DwmNlC;E8DvmNE;IAAgC,sCAAA;E9D0mNlC;E8DzmNE;IAAgC,yCAAA;E9D4mNlC;E8D1mNE;IAA8B,0BAAA;E9D6mNhC;E8D5mNE;IAA8B,4BAAA;E9D+mNhC;E8D9mNE;IAA8B,kCAAA;E9DinNhC;E8DhnNE;IAA8B,yBAAA;E9DmnNhC;E8DlnNE;IAA8B,uBAAA;E9DqnNhC;E8DpnNE;IAA8B,uBAAA;E9DunNhC;E8DtnNE;IAA8B,yBAAA;E9DynNhC;E8DxnNE;IAA8B,yBAAA;E9D2nNhC;E8DznNE;IAAoC,sCAAA;E9D4nNtC;E8D3nNE;IAAoC,oCAAA;E9D8nNtC;E8D7nNE;IAAoC,kCAAA;E9DgoNtC;E8D/nNE;IAAoC,yCAAA;E9DkoNtC;E8DjoNE;IAAoC,wCAAA;E9DooNtC;E8DloNE;IAAiC,kCAAA;E9DqoNnC;E8DpoNE;IAAiC,gCAAA;E9DuoNnC;E8DtoNE;IAAiC,8BAAA;E9DyoNnC;E8DxoNE;IAAiC,gCAAA;E9D2oNnC;E8D1oNE;IAAiC,+BAAA;E9D6oNnC;E8D3oNE;IAAkC,oCAAA;E9D8oNpC;E8D7oNE;IAAkC,kCAAA;E9DgpNpC;E8D/oNE;IAAkC,gCAAA;E9DkpNpC;E8DjpNE;IAAkC,uCAAA;E9DopNpC;E8DnpNE;IAAkC,sCAAA;E9DspNpC;E8DrpNE;IAAkC,iCAAA;E9DwpNpC;E8DtpNE;IAAgC,2BAAA;E9DypNlC;E8DxpNE;IAAgC,iCAAA;E9D2pNlC;E8D1pNE;IAAgC,+BAAA;E9D6pNlC;E8D5pNE;IAAgC,6BAAA;E9D+pNlC;E8D9pNE;IAAgC,+BAAA;E9DiqNlC;E8DhqNE;IAAgC,8BAAA;E9DmqNlC;AACF;AexpNI;E+ClDA;IAAgC,8BAAA;E9D8sNlC;E8D7sNE;IAAgC,iCAAA;E9DgtNlC;E8D/sNE;IAAgC,sCAAA;E9DktNlC;E8DjtNE;IAAgC,yCAAA;E9DotNlC;E8DltNE;IAA8B,0BAAA;E9DqtNhC;E8DptNE;IAA8B,4BAAA;E9DutNhC;E8DttNE;IAA8B,kCAAA;E9DytNhC;E8DxtNE;IAA8B,yBAAA;E9D2tNhC;E8D1tNE;IAA8B,uBAAA;E9D6tNhC;E8D5tNE;IAA8B,uBAAA;E9D+tNhC;E8D9tNE;IAA8B,yBAAA;E9DiuNhC;E8DhuNE;IAA8B,yBAAA;E9DmuNhC;E8DjuNE;IAAoC,sCAAA;E9DouNtC;E8DnuNE;IAAoC,oCAAA;E9DsuNtC;E8DruNE;IAAoC,kCAAA;E9DwuNtC;E8DvuNE;IAAoC,yCAAA;E9D0uNtC;E8DzuNE;IAAoC,wCAAA;E9D4uNtC;E8D1uNE;IAAiC,kCAAA;E9D6uNnC;E8D5uNE;IAAiC,gCAAA;E9D+uNnC;E8D9uNE;IAAiC,8BAAA;E9DivNnC;E8DhvNE;IAAiC,gCAAA;E9DmvNnC;E8DlvNE;IAAiC,+BAAA;E9DqvNnC;E8DnvNE;IAAkC,oCAAA;E9DsvNpC;E8DrvNE;IAAkC,kCAAA;E9DwvNpC;E8DvvNE;IAAkC,gCAAA;E9D0vNpC;E8DzvNE;IAAkC,uCAAA;E9D4vNpC;E8D3vNE;IAAkC,sCAAA;E9D8vNpC;E8D7vNE;IAAkC,iCAAA;E9DgwNpC;E8D9vNE;IAAgC,2BAAA;E9DiwNlC;E8DhwNE;IAAgC,iCAAA;E9DmwNlC;E8DlwNE;IAAgC,+BAAA;E9DqwNlC;E8DpwNE;IAAgC,6BAAA;E9DuwNlC;E8DtwNE;IAAgC,+BAAA;E9DywNlC;E8DxwNE;IAAgC,8BAAA;E9D2wNlC;AACF;AehwNI;E+ClDA;IAAgC,8BAAA;E9DszNlC;E8DrzNE;IAAgC,iCAAA;E9DwzNlC;E8DvzNE;IAAgC,sCAAA;E9D0zNlC;E8DzzNE;IAAgC,yCAAA;E9D4zNlC;E8D1zNE;IAA8B,0BAAA;E9D6zNhC;E8D5zNE;IAA8B,4BAAA;E9D+zNhC;E8D9zNE;IAA8B,kCAAA;E9Di0NhC;E8Dh0NE;IAA8B,yBAAA;E9Dm0NhC;E8Dl0NE;IAA8B,uBAAA;E9Dq0NhC;E8Dp0NE;IAA8B,uBAAA;E9Du0NhC;E8Dt0NE;IAA8B,yBAAA;E9Dy0NhC;E8Dx0NE;IAA8B,yBAAA;E9D20NhC;E8Dz0NE;IAAoC,sCAAA;E9D40NtC;E8D30NE;IAAoC,oCAAA;E9D80NtC;E8D70NE;IAAoC,kCAAA;E9Dg1NtC;E8D/0NE;IAAoC,yCAAA;E9Dk1NtC;E8Dj1NE;IAAoC,wCAAA;E9Do1NtC;E8Dl1NE;IAAiC,kCAAA;E9Dq1NnC;E8Dp1NE;IAAiC,gCAAA;E9Du1NnC;E8Dt1NE;IAAiC,8BAAA;E9Dy1NnC;E8Dx1NE;IAAiC,gCAAA;E9D21NnC;E8D11NE;IAAiC,+BAAA;E9D61NnC;E8D31NE;IAAkC,oCAAA;E9D81NpC;E8D71NE;IAAkC,kCAAA;E9Dg2NpC;E8D/1NE;IAAkC,gCAAA;E9Dk2NpC;E8Dj2NE;IAAkC,uCAAA;E9Do2NpC;E8Dn2NE;IAAkC,sCAAA;E9Ds2NpC;E8Dr2NE;IAAkC,iCAAA;E9Dw2NpC;E8Dt2NE;IAAgC,2BAAA;E9Dy2NlC;E8Dx2NE;IAAgC,iCAAA;E9D22NlC;E8D12NE;IAAgC,+BAAA;E9D62NlC;E8D52NE;IAAgC,6BAAA;E9D+2NlC;E8D92NE;IAAgC,+BAAA;E9Di3NlC;E8Dh3NE;IAAgC,8BAAA;E9Dm3NlC;AACF;Aex2NI;E+ClDA;IAAgC,8BAAA;E9D85NlC;E8D75NE;IAAgC,iCAAA;E9Dg6NlC;E8D/5NE;IAAgC,sCAAA;E9Dk6NlC;E8Dj6NE;IAAgC,yCAAA;E9Do6NlC;E8Dl6NE;IAA8B,0BAAA;E9Dq6NhC;E8Dp6NE;IAA8B,4BAAA;E9Du6NhC;E8Dt6NE;IAA8B,kCAAA;E9Dy6NhC;E8Dx6NE;IAA8B,yBAAA;E9D26NhC;E8D16NE;IAA8B,uBAAA;E9D66NhC;E8D56NE;IAA8B,uBAAA;E9D+6NhC;E8D96NE;IAA8B,yBAAA;E9Di7NhC;E8Dh7NE;IAA8B,yBAAA;E9Dm7NhC;E8Dj7NE;IAAoC,sCAAA;E9Do7NtC;E8Dn7NE;IAAoC,oCAAA;E9Ds7NtC;E8Dr7NE;IAAoC,kCAAA;E9Dw7NtC;E8Dv7NE;IAAoC,yCAAA;E9D07NtC;E8Dz7NE;IAAoC,wCAAA;E9D47NtC;E8D17NE;IAAiC,kCAAA;E9D67NnC;E8D57NE;IAAiC,gCAAA;E9D+7NnC;E8D97NE;IAAiC,8BAAA;E9Di8NnC;E8Dh8NE;IAAiC,gCAAA;E9Dm8NnC;E8Dl8NE;IAAiC,+BAAA;E9Dq8NnC;E8Dn8NE;IAAkC,oCAAA;E9Ds8NpC;E8Dr8NE;IAAkC,kCAAA;E9Dw8NpC;E8Dv8NE;IAAkC,gCAAA;E9D08NpC;E8Dz8NE;IAAkC,uCAAA;E9D48NpC;E8D38NE;IAAkC,sCAAA;E9D88NpC;E8D78NE;IAAkC,iCAAA;E9Dg9NpC;E8D98NE;IAAgC,2BAAA;E9Di9NlC;E8Dh9NE;IAAgC,iCAAA;E9Dm9NlC;E8Dl9NE;IAAgC,+BAAA;E9Dq9NlC;E8Dp9NE;IAAgC,6BAAA;E9Du9NlC;E8Dt9NE;IAAgC,+BAAA;E9Dy9NlC;E8Dx9NE;IAAgC,8BAAA;E9D29NlC;AACF;A+DtgOI;EAAwB,sBAAA;A/DygO5B;;A+DxgOI;EAAwB,uBAAA;A/D4gO5B;;A+D3gOI;EAAwB,sBAAA;A/D+gO5B;;Ae39NI;EgDtDA;IAAwB,sBAAA;E/DshO1B;E+DrhOE;IAAwB,uBAAA;E/DwhO1B;E+DvhOE;IAAwB,sBAAA;E/D0hO1B;AACF;Aev+NI;EgDtDA;IAAwB,sBAAA;E/DiiO1B;E+DhiOE;IAAwB,uBAAA;E/DmiO1B;E+DliOE;IAAwB,sBAAA;E/DqiO1B;AACF;Ael/NI;EgDtDA;IAAwB,sBAAA;E/D4iO1B;E+D3iOE;IAAwB,uBAAA;E/D8iO1B;E+D7iOE;IAAwB,sBAAA;E/DgjO1B;AACF;Ae7/NI;EgDtDA;IAAwB,sBAAA;E/DujO1B;E+DtjOE;IAAwB,uBAAA;E/DyjO1B;E+DxjOE;IAAwB,sBAAA;E/D2jO1B;AACF;AgEjkOE;EAAyB,mCAAA;KAAA,gCAAA;UAAA,2BAAA;AhEokO3B;;AgEpkOE;EAAyB,oCAAA;KAAA,iCAAA;UAAA,4BAAA;AhEwkO3B;;AgExkOE;EAAyB,oCAAA;KAAA,iCAAA;UAAA,4BAAA;AhE4kO3B;;AiE5kOE;EAAsB,yBAAA;AjEglOxB;;AiEhlOE;EAAsB,2BAAA;AjEolOxB;;AkEnlOE;EAAyB,2BAAA;AlEulO3B;;AkEvlOE;EAAyB,6BAAA;AlE2lO3B;;AkE3lOE;EAAyB,6BAAA;AlE+lO3B;;AkE/lOE;EAAyB,0BAAA;AlEmmO3B;;AkEnmOE;EAAyB,2BAAA;AlEumO3B;;AkElmOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a9DiqBkC;AJo8MpC;;AkElmOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a9DypBkC;AJ48MpC;;AkEjmOE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a9DipBgC;EJo9MlC;AACF;;AmE/nOA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ApEioOF;;AoEvnOE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;ApEynOJ;;AqEtpOA;EAAa,8DAAA;ArE0pOb;;AqEzpOA;EAAU,wDAAA;ArE6pOV;;AqE5pOA;EAAa,uDAAA;ArEgqOb;;AqE/pOA;EAAe,2BAAA;ArEmqOf;;AsElqOI;EAAuB,qBAAA;AtEsqO3B;;AsEtqOI;EAAuB,qBAAA;AtE0qO3B;;AsE1qOI;EAAuB,qBAAA;AtE8qO3B;;AsE9qOI;EAAuB,sBAAA;AtEkrO3B;;AsElrOI;EAAuB,sBAAA;AtEsrO3B;;AsEtrOI;EAAuB,sBAAA;AtE0rO3B;;AsE1rOI;EAAuB,sBAAA;AtE8rO3B;;AsE9rOI;EAAuB,sBAAA;AtEksO3B;;AsElsOI;EAAuB,uBAAA;AtEssO3B;;AsEtsOI;EAAuB,uBAAA;AtE0sO3B;;AsEtsOA;EAAU,0BAAA;AtE0sOV;;AsEzsOA;EAAU,2BAAA;AtE6sOV;;AsEzsOA;EAAc,2BAAA;AtE6sOd;;AsE5sOA;EAAc,4BAAA;AtEgtOd;;AsE9sOA;EAAU,uBAAA;AtEktOV;;AsEjtOA;EAAU,wBAAA;AtEqtOV;;AuE9tOQ;EAAgC,oBAAA;AvEkuOxC;;AuEjuOQ;;EAEE,wBAAA;AvEouOV;;AuEluOQ;;EAEE,0BAAA;AvEquOV;;AuEnuOQ;;EAEE,2BAAA;AvEsuOV;;AuEpuOQ;;EAEE,yBAAA;AvEuuOV;;AuEtvOQ;EAAgC,0BAAA;AvE0vOxC;;AuEzvOQ;;EAEE,8BAAA;AvE4vOV;;AuE1vOQ;;EAEE,gCAAA;AvE6vOV;;AuE3vOQ;;EAEE,iCAAA;AvE8vOV;;AuE5vOQ;;EAEE,+BAAA;AvE+vOV;;AuE9wOQ;EAAgC,yBAAA;AvEkxOxC;;AuEjxOQ;;EAEE,6BAAA;AvEoxOV;;AuElxOQ;;EAEE,+BAAA;AvEqxOV;;AuEnxOQ;;EAEE,gCAAA;AvEsxOV;;AuEpxOQ;;EAEE,8BAAA;AvEuxOV;;AuEtyOQ;EAAgC,uBAAA;AvE0yOxC;;AuEzyOQ;;EAEE,2BAAA;AvE4yOV;;AuE1yOQ;;EAEE,6BAAA;AvE6yOV;;AuE3yOQ;;EAEE,8BAAA;AvE8yOV;;AuE5yOQ;;EAEE,4BAAA;AvE+yOV;;AuE9zOQ;EAAgC,yBAAA;AvEk0OxC;;AuEj0OQ;;EAEE,6BAAA;AvEo0OV;;AuEl0OQ;;EAEE,+BAAA;AvEq0OV;;AuEn0OQ;;EAEE,gCAAA;AvEs0OV;;AuEp0OQ;;EAEE,8BAAA;AvEu0OV;;AuEt1OQ;EAAgC,uBAAA;AvE01OxC;;AuEz1OQ;;EAEE,2BAAA;AvE41OV;;AuE11OQ;;EAEE,6BAAA;AvE61OV;;AuE31OQ;;EAEE,8BAAA;AvE81OV;;AuE51OQ;;EAEE,4BAAA;AvE+1OV;;AuE92OQ;EAAgC,qBAAA;AvEk3OxC;;AuEj3OQ;;EAEE,yBAAA;AvEo3OV;;AuEl3OQ;;EAEE,2BAAA;AvEq3OV;;AuEn3OQ;;EAEE,4BAAA;AvEs3OV;;AuEp3OQ;;EAEE,0BAAA;AvEu3OV;;AuEt4OQ;EAAgC,2BAAA;AvE04OxC;;AuEz4OQ;;EAEE,+BAAA;AvE44OV;;AuE14OQ;;EAEE,iCAAA;AvE64OV;;AuE34OQ;;EAEE,kCAAA;AvE84OV;;AuE54OQ;;EAEE,gCAAA;AvE+4OV;;AuE95OQ;EAAgC,0BAAA;AvEk6OxC;;AuEj6OQ;;EAEE,8BAAA;AvEo6OV;;AuEl6OQ;;EAEE,gCAAA;AvEq6OV;;AuEn6OQ;;EAEE,iCAAA;AvEs6OV;;AuEp6OQ;;EAEE,+BAAA;AvEu6OV;;AuEt7OQ;EAAgC,wBAAA;AvE07OxC;;AuEz7OQ;;EAEE,4BAAA;AvE47OV;;AuE17OQ;;EAEE,8BAAA;AvE67OV;;AuE37OQ;;EAEE,+BAAA;AvE87OV;;AuE57OQ;;EAEE,6BAAA;AvE+7OV;;AuE98OQ;EAAgC,0BAAA;AvEk9OxC;;AuEj9OQ;;EAEE,8BAAA;AvEo9OV;;AuEl9OQ;;EAEE,gCAAA;AvEq9OV;;AuEn9OQ;;EAEE,iCAAA;AvEs9OV;;AuEp9OQ;;EAEE,+BAAA;AvEu9OV;;AuEt+OQ;EAAgC,wBAAA;AvE0+OxC;;AuEz+OQ;;EAEE,4BAAA;AvE4+OV;;AuE1+OQ;;EAEE,8BAAA;AvE6+OV;;AuE3+OQ;;EAEE,+BAAA;AvE8+OV;;AuE5+OQ;;EAEE,6BAAA;AvE++OV;;AuEv+OQ;EAAwB,2BAAA;AvE2+OhC;;AuE1+OQ;;EAEE,+BAAA;AvE6+OV;;AuE3+OQ;;EAEE,iCAAA;AvE8+OV;;AuE5+OQ;;EAEE,kCAAA;AvE++OV;;AuE7+OQ;;EAEE,gCAAA;AvEg/OV;;AuE//OQ;EAAwB,0BAAA;AvEmgPhC;;AuElgPQ;;EAEE,8BAAA;AvEqgPV;;AuEngPQ;;EAEE,gCAAA;AvEsgPV;;AuEpgPQ;;EAEE,iCAAA;AvEugPV;;AuErgPQ;;EAEE,+BAAA;AvEwgPV;;AuEvhPQ;EAAwB,wBAAA;AvE2hPhC;;AuE1hPQ;;EAEE,4BAAA;AvE6hPV;;AuE3hPQ;;EAEE,8BAAA;AvE8hPV;;AuE5hPQ;;EAEE,+BAAA;AvE+hPV;;AuE7hPQ;;EAEE,6BAAA;AvEgiPV;;AuE/iPQ;EAAwB,0BAAA;AvEmjPhC;;AuEljPQ;;EAEE,8BAAA;AvEqjPV;;AuEnjPQ;;EAEE,gCAAA;AvEsjPV;;AuEpjPQ;;EAEE,iCAAA;AvEujPV;;AuErjPQ;;EAEE,+BAAA;AvEwjPV;;AuEvkPQ;EAAwB,wBAAA;AvE2kPhC;;AuE1kPQ;;EAEE,4BAAA;AvE6kPV;;AuE3kPQ;;EAEE,8BAAA;AvE8kPV;;AuE5kPQ;;EAEE,+BAAA;AvE+kPV;;AuE7kPQ;;EAEE,6BAAA;AvEglPV;;AuE1kPI;EAAmB,uBAAA;AvE8kPvB;;AuE7kPI;;EAEE,2BAAA;AvEglPN;;AuE9kPI;;EAEE,6BAAA;AvEilPN;;AuE/kPI;;EAEE,8BAAA;AvEklPN;;AuEhlPI;;EAEE,4BAAA;AvEmlPN;;Ae5lPI;EwDlDI;IAAgC,oBAAA;EvEmpPtC;EuElpPM;;IAEE,wBAAA;EvEopPR;EuElpPM;;IAEE,0BAAA;EvEopPR;EuElpPM;;IAEE,2BAAA;EvEopPR;EuElpPM;;IAEE,yBAAA;EvEopPR;EuEnqPM;IAAgC,0BAAA;EvEsqPtC;EuErqPM;;IAEE,8BAAA;EvEuqPR;EuErqPM;;IAEE,gCAAA;EvEuqPR;EuErqPM;;IAEE,iCAAA;EvEuqPR;EuErqPM;;IAEE,+BAAA;EvEuqPR;EuEtrPM;IAAgC,yBAAA;EvEyrPtC;EuExrPM;;IAEE,6BAAA;EvE0rPR;EuExrPM;;IAEE,+BAAA;EvE0rPR;EuExrPM;;IAEE,gCAAA;EvE0rPR;EuExrPM;;IAEE,8BAAA;EvE0rPR;EuEzsPM;IAAgC,uBAAA;EvE4sPtC;EuE3sPM;;IAEE,2BAAA;EvE6sPR;EuE3sPM;;IAEE,6BAAA;EvE6sPR;EuE3sPM;;IAEE,8BAAA;EvE6sPR;EuE3sPM;;IAEE,4BAAA;EvE6sPR;EuE5tPM;IAAgC,yBAAA;EvE+tPtC;EuE9tPM;;IAEE,6BAAA;EvEguPR;EuE9tPM;;IAEE,+BAAA;EvEguPR;EuE9tPM;;IAEE,gCAAA;EvEguPR;EuE9tPM;;IAEE,8BAAA;EvEguPR;EuE/uPM;IAAgC,uBAAA;EvEkvPtC;EuEjvPM;;IAEE,2BAAA;EvEmvPR;EuEjvPM;;IAEE,6BAAA;EvEmvPR;EuEjvPM;;IAEE,8BAAA;EvEmvPR;EuEjvPM;;IAEE,4BAAA;EvEmvPR;EuElwPM;IAAgC,qBAAA;EvEqwPtC;EuEpwPM;;IAEE,yBAAA;EvEswPR;EuEpwPM;;IAEE,2BAAA;EvEswPR;EuEpwPM;;IAEE,4BAAA;EvEswPR;EuEpwPM;;IAEE,0BAAA;EvEswPR;EuErxPM;IAAgC,2BAAA;EvEwxPtC;EuEvxPM;;IAEE,+BAAA;EvEyxPR;EuEvxPM;;IAEE,iCAAA;EvEyxPR;EuEvxPM;;IAEE,kCAAA;EvEyxPR;EuEvxPM;;IAEE,gCAAA;EvEyxPR;EuExyPM;IAAgC,0BAAA;EvE2yPtC;EuE1yPM;;IAEE,8BAAA;EvE4yPR;EuE1yPM;;IAEE,gCAAA;EvE4yPR;EuE1yPM;;IAEE,iCAAA;EvE4yPR;EuE1yPM;;IAEE,+BAAA;EvE4yPR;EuE3zPM;IAAgC,wBAAA;EvE8zPtC;EuE7zPM;;IAEE,4BAAA;EvE+zPR;EuE7zPM;;IAEE,8BAAA;EvE+zPR;EuE7zPM;;IAEE,+BAAA;EvE+zPR;EuE7zPM;;IAEE,6BAAA;EvE+zPR;EuE90PM;IAAgC,0BAAA;EvEi1PtC;EuEh1PM;;IAEE,8BAAA;EvEk1PR;EuEh1PM;;IAEE,gCAAA;EvEk1PR;EuEh1PM;;IAEE,iCAAA;EvEk1PR;EuEh1PM;;IAEE,+BAAA;EvEk1PR;EuEj2PM;IAAgC,wBAAA;EvEo2PtC;EuEn2PM;;IAEE,4BAAA;EvEq2PR;EuEn2PM;;IAEE,8BAAA;EvEq2PR;EuEn2PM;;IAEE,+BAAA;EvEq2PR;EuEn2PM;;IAEE,6BAAA;EvEq2PR;EuE71PM;IAAwB,2BAAA;EvEg2P9B;EuE/1PM;;IAEE,+BAAA;EvEi2PR;EuE/1PM;;IAEE,iCAAA;EvEi2PR;EuE/1PM;;IAEE,kCAAA;EvEi2PR;EuE/1PM;;IAEE,gCAAA;EvEi2PR;EuEh3PM;IAAwB,0BAAA;EvEm3P9B;EuEl3PM;;IAEE,8BAAA;EvEo3PR;EuEl3PM;;IAEE,gCAAA;EvEo3PR;EuEl3PM;;IAEE,iCAAA;EvEo3PR;EuEl3PM;;IAEE,+BAAA;EvEo3PR;EuEn4PM;IAAwB,wBAAA;EvEs4P9B;EuEr4PM;;IAEE,4BAAA;EvEu4PR;EuEr4PM;;IAEE,8BAAA;EvEu4PR;EuEr4PM;;IAEE,+BAAA;EvEu4PR;EuEr4PM;;IAEE,6BAAA;EvEu4PR;EuEt5PM;IAAwB,0BAAA;EvEy5P9B;EuEx5PM;;IAEE,8BAAA;EvE05PR;EuEx5PM;;IAEE,gCAAA;EvE05PR;EuEx5PM;;IAEE,iCAAA;EvE05PR;EuEx5PM;;IAEE,+BAAA;EvE05PR;EuEz6PM;IAAwB,wBAAA;EvE46P9B;EuE36PM;;IAEE,4BAAA;EvE66PR;EuE36PM;;IAEE,8BAAA;EvE66PR;EuE36PM;;IAEE,+BAAA;EvE66PR;EuE36PM;;IAEE,6BAAA;EvE66PR;EuEv6PE;IAAmB,uBAAA;EvE06PrB;EuEz6PE;;IAEE,2BAAA;EvE26PJ;EuEz6PE;;IAEE,6BAAA;EvE26PJ;EuEz6PE;;IAEE,8BAAA;EvE26PJ;EuEz6PE;;IAEE,4BAAA;EvE26PJ;AACF;Aer7PI;EwDlDI;IAAgC,oBAAA;EvE2+PtC;EuE1+PM;;IAEE,wBAAA;EvE4+PR;EuE1+PM;;IAEE,0BAAA;EvE4+PR;EuE1+PM;;IAEE,2BAAA;EvE4+PR;EuE1+PM;;IAEE,yBAAA;EvE4+PR;EuE3/PM;IAAgC,0BAAA;EvE8/PtC;EuE7/PM;;IAEE,8BAAA;EvE+/PR;EuE7/PM;;IAEE,gCAAA;EvE+/PR;EuE7/PM;;IAEE,iCAAA;EvE+/PR;EuE7/PM;;IAEE,+BAAA;EvE+/PR;EuE9gQM;IAAgC,yBAAA;EvEihQtC;EuEhhQM;;IAEE,6BAAA;EvEkhQR;EuEhhQM;;IAEE,+BAAA;EvEkhQR;EuEhhQM;;IAEE,gCAAA;EvEkhQR;EuEhhQM;;IAEE,8BAAA;EvEkhQR;EuEjiQM;IAAgC,uBAAA;EvEoiQtC;EuEniQM;;IAEE,2BAAA;EvEqiQR;EuEniQM;;IAEE,6BAAA;EvEqiQR;EuEniQM;;IAEE,8BAAA;EvEqiQR;EuEniQM;;IAEE,4BAAA;EvEqiQR;EuEpjQM;IAAgC,yBAAA;EvEujQtC;EuEtjQM;;IAEE,6BAAA;EvEwjQR;EuEtjQM;;IAEE,+BAAA;EvEwjQR;EuEtjQM;;IAEE,gCAAA;EvEwjQR;EuEtjQM;;IAEE,8BAAA;EvEwjQR;EuEvkQM;IAAgC,uBAAA;EvE0kQtC;EuEzkQM;;IAEE,2BAAA;EvE2kQR;EuEzkQM;;IAEE,6BAAA;EvE2kQR;EuEzkQM;;IAEE,8BAAA;EvE2kQR;EuEzkQM;;IAEE,4BAAA;EvE2kQR;EuE1lQM;IAAgC,qBAAA;EvE6lQtC;EuE5lQM;;IAEE,yBAAA;EvE8lQR;EuE5lQM;;IAEE,2BAAA;EvE8lQR;EuE5lQM;;IAEE,4BAAA;EvE8lQR;EuE5lQM;;IAEE,0BAAA;EvE8lQR;EuE7mQM;IAAgC,2BAAA;EvEgnQtC;EuE/mQM;;IAEE,+BAAA;EvEinQR;EuE/mQM;;IAEE,iCAAA;EvEinQR;EuE/mQM;;IAEE,kCAAA;EvEinQR;EuE/mQM;;IAEE,gCAAA;EvEinQR;EuEhoQM;IAAgC,0BAAA;EvEmoQtC;EuEloQM;;IAEE,8BAAA;EvEooQR;EuEloQM;;IAEE,gCAAA;EvEooQR;EuEloQM;;IAEE,iCAAA;EvEooQR;EuEloQM;;IAEE,+BAAA;EvEooQR;EuEnpQM;IAAgC,wBAAA;EvEspQtC;EuErpQM;;IAEE,4BAAA;EvEupQR;EuErpQM;;IAEE,8BAAA;EvEupQR;EuErpQM;;IAEE,+BAAA;EvEupQR;EuErpQM;;IAEE,6BAAA;EvEupQR;EuEtqQM;IAAgC,0BAAA;EvEyqQtC;EuExqQM;;IAEE,8BAAA;EvE0qQR;EuExqQM;;IAEE,gCAAA;EvE0qQR;EuExqQM;;IAEE,iCAAA;EvE0qQR;EuExqQM;;IAEE,+BAAA;EvE0qQR;EuEzrQM;IAAgC,wBAAA;EvE4rQtC;EuE3rQM;;IAEE,4BAAA;EvE6rQR;EuE3rQM;;IAEE,8BAAA;EvE6rQR;EuE3rQM;;IAEE,+BAAA;EvE6rQR;EuE3rQM;;IAEE,6BAAA;EvE6rQR;EuErrQM;IAAwB,2BAAA;EvEwrQ9B;EuEvrQM;;IAEE,+BAAA;EvEyrQR;EuEvrQM;;IAEE,iCAAA;EvEyrQR;EuEvrQM;;IAEE,kCAAA;EvEyrQR;EuEvrQM;;IAEE,gCAAA;EvEyrQR;EuExsQM;IAAwB,0BAAA;EvE2sQ9B;EuE1sQM;;IAEE,8BAAA;EvE4sQR;EuE1sQM;;IAEE,gCAAA;EvE4sQR;EuE1sQM;;IAEE,iCAAA;EvE4sQR;EuE1sQM;;IAEE,+BAAA;EvE4sQR;EuE3tQM;IAAwB,wBAAA;EvE8tQ9B;EuE7tQM;;IAEE,4BAAA;EvE+tQR;EuE7tQM;;IAEE,8BAAA;EvE+tQR;EuE7tQM;;IAEE,+BAAA;EvE+tQR;EuE7tQM;;IAEE,6BAAA;EvE+tQR;EuE9uQM;IAAwB,0BAAA;EvEivQ9B;EuEhvQM;;IAEE,8BAAA;EvEkvQR;EuEhvQM;;IAEE,gCAAA;EvEkvQR;EuEhvQM;;IAEE,iCAAA;EvEkvQR;EuEhvQM;;IAEE,+BAAA;EvEkvQR;EuEjwQM;IAAwB,wBAAA;EvEowQ9B;EuEnwQM;;IAEE,4BAAA;EvEqwQR;EuEnwQM;;IAEE,8BAAA;EvEqwQR;EuEnwQM;;IAEE,+BAAA;EvEqwQR;EuEnwQM;;IAEE,6BAAA;EvEqwQR;EuE/vQE;IAAmB,uBAAA;EvEkwQrB;EuEjwQE;;IAEE,2BAAA;EvEmwQJ;EuEjwQE;;IAEE,6BAAA;EvEmwQJ;EuEjwQE;;IAEE,8BAAA;EvEmwQJ;EuEjwQE;;IAEE,4BAAA;EvEmwQJ;AACF;Ae7wQI;EwDlDI;IAAgC,oBAAA;EvEm0QtC;EuEl0QM;;IAEE,wBAAA;EvEo0QR;EuEl0QM;;IAEE,0BAAA;EvEo0QR;EuEl0QM;;IAEE,2BAAA;EvEo0QR;EuEl0QM;;IAEE,yBAAA;EvEo0QR;EuEn1QM;IAAgC,0BAAA;EvEs1QtC;EuEr1QM;;IAEE,8BAAA;EvEu1QR;EuEr1QM;;IAEE,gCAAA;EvEu1QR;EuEr1QM;;IAEE,iCAAA;EvEu1QR;EuEr1QM;;IAEE,+BAAA;EvEu1QR;EuEt2QM;IAAgC,yBAAA;EvEy2QtC;EuEx2QM;;IAEE,6BAAA;EvE02QR;EuEx2QM;;IAEE,+BAAA;EvE02QR;EuEx2QM;;IAEE,gCAAA;EvE02QR;EuEx2QM;;IAEE,8BAAA;EvE02QR;EuEz3QM;IAAgC,uBAAA;EvE43QtC;EuE33QM;;IAEE,2BAAA;EvE63QR;EuE33QM;;IAEE,6BAAA;EvE63QR;EuE33QM;;IAEE,8BAAA;EvE63QR;EuE33QM;;IAEE,4BAAA;EvE63QR;EuE54QM;IAAgC,yBAAA;EvE+4QtC;EuE94QM;;IAEE,6BAAA;EvEg5QR;EuE94QM;;IAEE,+BAAA;EvEg5QR;EuE94QM;;IAEE,gCAAA;EvEg5QR;EuE94QM;;IAEE,8BAAA;EvEg5QR;EuE/5QM;IAAgC,uBAAA;EvEk6QtC;EuEj6QM;;IAEE,2BAAA;EvEm6QR;EuEj6QM;;IAEE,6BAAA;EvEm6QR;EuEj6QM;;IAEE,8BAAA;EvEm6QR;EuEj6QM;;IAEE,4BAAA;EvEm6QR;EuEl7QM;IAAgC,qBAAA;EvEq7QtC;EuEp7QM;;IAEE,yBAAA;EvEs7QR;EuEp7QM;;IAEE,2BAAA;EvEs7QR;EuEp7QM;;IAEE,4BAAA;EvEs7QR;EuEp7QM;;IAEE,0BAAA;EvEs7QR;EuEr8QM;IAAgC,2BAAA;EvEw8QtC;EuEv8QM;;IAEE,+BAAA;EvEy8QR;EuEv8QM;;IAEE,iCAAA;EvEy8QR;EuEv8QM;;IAEE,kCAAA;EvEy8QR;EuEv8QM;;IAEE,gCAAA;EvEy8QR;EuEx9QM;IAAgC,0BAAA;EvE29QtC;EuE19QM;;IAEE,8BAAA;EvE49QR;EuE19QM;;IAEE,gCAAA;EvE49QR;EuE19QM;;IAEE,iCAAA;EvE49QR;EuE19QM;;IAEE,+BAAA;EvE49QR;EuE3+QM;IAAgC,wBAAA;EvE8+QtC;EuE7+QM;;IAEE,4BAAA;EvE++QR;EuE7+QM;;IAEE,8BAAA;EvE++QR;EuE7+QM;;IAEE,+BAAA;EvE++QR;EuE7+QM;;IAEE,6BAAA;EvE++QR;EuE9/QM;IAAgC,0BAAA;EvEigRtC;EuEhgRM;;IAEE,8BAAA;EvEkgRR;EuEhgRM;;IAEE,gCAAA;EvEkgRR;EuEhgRM;;IAEE,iCAAA;EvEkgRR;EuEhgRM;;IAEE,+BAAA;EvEkgRR;EuEjhRM;IAAgC,wBAAA;EvEohRtC;EuEnhRM;;IAEE,4BAAA;EvEqhRR;EuEnhRM;;IAEE,8BAAA;EvEqhRR;EuEnhRM;;IAEE,+BAAA;EvEqhRR;EuEnhRM;;IAEE,6BAAA;EvEqhRR;EuE7gRM;IAAwB,2BAAA;EvEghR9B;EuE/gRM;;IAEE,+BAAA;EvEihRR;EuE/gRM;;IAEE,iCAAA;EvEihRR;EuE/gRM;;IAEE,kCAAA;EvEihRR;EuE/gRM;;IAEE,gCAAA;EvEihRR;EuEhiRM;IAAwB,0BAAA;EvEmiR9B;EuEliRM;;IAEE,8BAAA;EvEoiRR;EuEliRM;;IAEE,gCAAA;EvEoiRR;EuEliRM;;IAEE,iCAAA;EvEoiRR;EuEliRM;;IAEE,+BAAA;EvEoiRR;EuEnjRM;IAAwB,wBAAA;EvEsjR9B;EuErjRM;;IAEE,4BAAA;EvEujRR;EuErjRM;;IAEE,8BAAA;EvEujRR;EuErjRM;;IAEE,+BAAA;EvEujRR;EuErjRM;;IAEE,6BAAA;EvEujRR;EuEtkRM;IAAwB,0BAAA;EvEykR9B;EuExkRM;;IAEE,8BAAA;EvE0kRR;EuExkRM;;IAEE,gCAAA;EvE0kRR;EuExkRM;;IAEE,iCAAA;EvE0kRR;EuExkRM;;IAEE,+BAAA;EvE0kRR;EuEzlRM;IAAwB,wBAAA;EvE4lR9B;EuE3lRM;;IAEE,4BAAA;EvE6lRR;EuE3lRM;;IAEE,8BAAA;EvE6lRR;EuE3lRM;;IAEE,+BAAA;EvE6lRR;EuE3lRM;;IAEE,6BAAA;EvE6lRR;EuEvlRE;IAAmB,uBAAA;EvE0lRrB;EuEzlRE;;IAEE,2BAAA;EvE2lRJ;EuEzlRE;;IAEE,6BAAA;EvE2lRJ;EuEzlRE;;IAEE,8BAAA;EvE2lRJ;EuEzlRE;;IAEE,4BAAA;EvE2lRJ;AACF;AermRI;EwDlDI;IAAgC,oBAAA;EvE2pRtC;EuE1pRM;;IAEE,wBAAA;EvE4pRR;EuE1pRM;;IAEE,0BAAA;EvE4pRR;EuE1pRM;;IAEE,2BAAA;EvE4pRR;EuE1pRM;;IAEE,yBAAA;EvE4pRR;EuE3qRM;IAAgC,0BAAA;EvE8qRtC;EuE7qRM;;IAEE,8BAAA;EvE+qRR;EuE7qRM;;IAEE,gCAAA;EvE+qRR;EuE7qRM;;IAEE,iCAAA;EvE+qRR;EuE7qRM;;IAEE,+BAAA;EvE+qRR;EuE9rRM;IAAgC,yBAAA;EvEisRtC;EuEhsRM;;IAEE,6BAAA;EvEksRR;EuEhsRM;;IAEE,+BAAA;EvEksRR;EuEhsRM;;IAEE,gCAAA;EvEksRR;EuEhsRM;;IAEE,8BAAA;EvEksRR;EuEjtRM;IAAgC,uBAAA;EvEotRtC;EuEntRM;;IAEE,2BAAA;EvEqtRR;EuEntRM;;IAEE,6BAAA;EvEqtRR;EuEntRM;;IAEE,8BAAA;EvEqtRR;EuEntRM;;IAEE,4BAAA;EvEqtRR;EuEpuRM;IAAgC,yBAAA;EvEuuRtC;EuEtuRM;;IAEE,6BAAA;EvEwuRR;EuEtuRM;;IAEE,+BAAA;EvEwuRR;EuEtuRM;;IAEE,gCAAA;EvEwuRR;EuEtuRM;;IAEE,8BAAA;EvEwuRR;EuEvvRM;IAAgC,uBAAA;EvE0vRtC;EuEzvRM;;IAEE,2BAAA;EvE2vRR;EuEzvRM;;IAEE,6BAAA;EvE2vRR;EuEzvRM;;IAEE,8BAAA;EvE2vRR;EuEzvRM;;IAEE,4BAAA;EvE2vRR;EuE1wRM;IAAgC,qBAAA;EvE6wRtC;EuE5wRM;;IAEE,yBAAA;EvE8wRR;EuE5wRM;;IAEE,2BAAA;EvE8wRR;EuE5wRM;;IAEE,4BAAA;EvE8wRR;EuE5wRM;;IAEE,0BAAA;EvE8wRR;EuE7xRM;IAAgC,2BAAA;EvEgyRtC;EuE/xRM;;IAEE,+BAAA;EvEiyRR;EuE/xRM;;IAEE,iCAAA;EvEiyRR;EuE/xRM;;IAEE,kCAAA;EvEiyRR;EuE/xRM;;IAEE,gCAAA;EvEiyRR;EuEhzRM;IAAgC,0BAAA;EvEmzRtC;EuElzRM;;IAEE,8BAAA;EvEozRR;EuElzRM;;IAEE,gCAAA;EvEozRR;EuElzRM;;IAEE,iCAAA;EvEozRR;EuElzRM;;IAEE,+BAAA;EvEozRR;EuEn0RM;IAAgC,wBAAA;EvEs0RtC;EuEr0RM;;IAEE,4BAAA;EvEu0RR;EuEr0RM;;IAEE,8BAAA;EvEu0RR;EuEr0RM;;IAEE,+BAAA;EvEu0RR;EuEr0RM;;IAEE,6BAAA;EvEu0RR;EuEt1RM;IAAgC,0BAAA;EvEy1RtC;EuEx1RM;;IAEE,8BAAA;EvE01RR;EuEx1RM;;IAEE,gCAAA;EvE01RR;EuEx1RM;;IAEE,iCAAA;EvE01RR;EuEx1RM;;IAEE,+BAAA;EvE01RR;EuEz2RM;IAAgC,wBAAA;EvE42RtC;EuE32RM;;IAEE,4BAAA;EvE62RR;EuE32RM;;IAEE,8BAAA;EvE62RR;EuE32RM;;IAEE,+BAAA;EvE62RR;EuE32RM;;IAEE,6BAAA;EvE62RR;EuEr2RM;IAAwB,2BAAA;EvEw2R9B;EuEv2RM;;IAEE,+BAAA;EvEy2RR;EuEv2RM;;IAEE,iCAAA;EvEy2RR;EuEv2RM;;IAEE,kCAAA;EvEy2RR;EuEv2RM;;IAEE,gCAAA;EvEy2RR;EuEx3RM;IAAwB,0BAAA;EvE23R9B;EuE13RM;;IAEE,8BAAA;EvE43RR;EuE13RM;;IAEE,gCAAA;EvE43RR;EuE13RM;;IAEE,iCAAA;EvE43RR;EuE13RM;;IAEE,+BAAA;EvE43RR;EuE34RM;IAAwB,wBAAA;EvE84R9B;EuE74RM;;IAEE,4BAAA;EvE+4RR;EuE74RM;;IAEE,8BAAA;EvE+4RR;EuE74RM;;IAEE,+BAAA;EvE+4RR;EuE74RM;;IAEE,6BAAA;EvE+4RR;EuE95RM;IAAwB,0BAAA;EvEi6R9B;EuEh6RM;;IAEE,8BAAA;EvEk6RR;EuEh6RM;;IAEE,gCAAA;EvEk6RR;EuEh6RM;;IAEE,iCAAA;EvEk6RR;EuEh6RM;;IAEE,+BAAA;EvEk6RR;EuEj7RM;IAAwB,wBAAA;EvEo7R9B;EuEn7RM;;IAEE,4BAAA;EvEq7RR;EuEn7RM;;IAEE,8BAAA;EvEq7RR;EuEn7RM;;IAEE,+BAAA;EvEq7RR;EuEn7RM;;IAEE,6BAAA;EvEq7RR;EuE/6RE;IAAmB,uBAAA;EvEk7RrB;EuEj7RE;;IAEE,2BAAA;EvEm7RJ;EuEj7RE;;IAEE,6BAAA;EvEm7RJ;EuEj7RE;;IAEE,8BAAA;EvEm7RJ;EuEj7RE;;IAEE,4BAAA;EvEm7RJ;AACF;AwEp/RE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AxEo/RJ;;AyE9/RA;EAAkB,4GAAA;AzEkgSlB;;AyE9/RA;EAAiB,8BAAA;AzEkgSjB;;AyEjgSA;EAAiB,8BAAA;AzEqgSjB;;AyEpgSA;EAAiB,8BAAA;AzEwgSjB;;AyEvgSA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A1EohSF;;AyErgSI;EAAwB,2BAAA;AzEygS5B;;AyExgSI;EAAwB,4BAAA;AzE4gS5B;;AyE3gSI;EAAwB,6BAAA;AzE+gS5B;;Ae1+RI;E0DvCA;IAAwB,2BAAA;EzEshS1B;EyErhSE;IAAwB,4BAAA;EzEwhS1B;EyEvhSE;IAAwB,6BAAA;EzE0hS1B;AACF;Aet/RI;E0DvCA;IAAwB,2BAAA;EzEiiS1B;EyEhiSE;IAAwB,4BAAA;EzEmiS1B;EyEliSE;IAAwB,6BAAA;EzEqiS1B;AACF;AejgSI;E0DvCA;IAAwB,2BAAA;EzE4iS1B;EyE3iSE;IAAwB,4BAAA;EzE8iS1B;EyE7iSE;IAAwB,6BAAA;EzEgjS1B;AACF;Ae5gSI;E0DvCA;IAAwB,2BAAA;EzEujS1B;EyEtjSE;IAAwB,4BAAA;EzEyjS1B;EyExjSE;IAAwB,6BAAA;EzE2jS1B;AACF;AyEtjSA;EAAmB,oCAAA;AzEyjSnB;;AyExjSA;EAAmB,oCAAA;AzE4jSnB;;AyE3jSA;EAAmB,qCAAA;AzE+jSnB;;AyE3jSA;EAAuB,2BAAA;AzE+jSvB;;AyE9jSA;EAAuB,+BAAA;AzEkkSvB;;AyEjkSA;EAAuB,2BAAA;AzEqkSvB;;AyEpkSA;EAAuB,2BAAA;AzEwkSvB;;AyEvkSA;EAAuB,8BAAA;AzE2kSvB;;AyE1kSA;EAAuB,6BAAA;AzE8kSvB;;AyE1kSA;EAAc,sBAAA;AzE8kSd;;A2ErnSE;EACE,yBAAA;A3EwnSJ;;AM9mSE;EqELM,yCAAA;A3EunSR;;A2E7nSE;EACE,yBAAA;A3EgoSJ;;AMtnSE;EqELM,gEAAA;A3E+nSR;;A2EroSE;EACE,yBAAA;A3EwoSJ;;AM9nSE;EqELM,iEAAA;A3EuoSR;;A2E7oSE;EACE,yBAAA;A3EgpSJ;;AMtoSE;EqELM,6CAAA;A3E+oSR;;A2ErpSE;EACE,yBAAA;A3EwpSJ;;AM9oSE;EqELM,wCAAA;A3EupSR;;A2E7pSE;EACE,yBAAA;A3EgqSJ;;AMtpSE;EqELM,iCAAA;A3E+pSR;;A2ErqSE;EACE,yBAAA;A3EwqSJ;;AM9pSE;EqELM,+CAAA;A3EuqSR;;A2E7qSE;EACE,yBAAA;A3EgrSJ;;AMtqSE;EqELM,0DAAA;A3E+qSR;;AyExoSA;EAAa,yBAAA;AzE4oSb;;AyE3oSA;EAAc,yBAAA;AzE+oSd;;AyE7oSA;EAAiB,oCAAA;AzEipSjB;;AyEhpSA;EAAiB,0CAAA;AzEopSjB;;AyEhpSA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A5E2sSF;;AyEppSA;EAAwB,gCAAA;AzEwpSxB;;AyEtpSA;EACE,iCAAA;EACA,gCAAA;AzEypSF;;AyEppSA;EAAc,yBAAA;AzEwpSd;;A6EztSA;EACE,8BAAA;A7E4tSF;;A6EztSA;EACE,6BAAA;A7E4tSF;;A8E5tSE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E9E4tSJ;E8ExtSI;IACE,0BAAA;E9E0tSN;E8EjtSE;IACE,6BAAA;E9EmtSJ;E8ErsSE;IACE,gCAAA;E9EusSJ;E8ErsSE;;IAEE,yBAAA;IACA,wBAAA;E9EusSJ;E8EpsSE;;IAEE,wBAAA;E9EssSJ;E8EnsSE;;;IAGE,UAAA;IACA,SAAA;E9EqsSJ;E8ElsSE;;IAEE,uBAAA;E9EosSJ;E8E5rSE;IACE,Q1E2iC8B;EJmpQlC;E8E5rSE;IACE,2BAAA;E9E8rSJ;E8E5rSE;IACE,2BAAA;E9E8rSJ;E8E1rSE;IACE,aAAA;E9E4rSJ;E8E1rSE;IACE,sBAAA;E9E4rSJ;E8EzrSE;IACE,oCAAA;E9E2rSJ;E8EzrSI;;IAEE,iCAAA;E9E2rSN;E8EtrSI;;IAEE,oCAAA;E9EwrSN;E8EprSE;IACE,cAAA;E9EsrSJ;E8EprSI;;;;IAIE,qB1E9GG;EJoyST;E8ElrSE;IACE,cAAA;IACA,qB1EpHK;EJwyST;AACF","sourcesContent":["$font-size-base: .9rem;\n\n$theme-colors: (\n    \"primary\":#045fb0,\n    \"danger\": #580000,\n    \"success\": #70A363,\n    \"secondary\": #668586,\n    \"info\": #E8E8E8,\n);\n\n.table>tbody>tr>td {\n    vertical-align: middle;\n}\n\n@for $i from 1 through 10 {\n    .rounded-l#{$i} {\n        border-radius: $i * 3px !important;\n        overflow: hidden;\n        border : 1px solid lightgray !important;\n    }\n}\n\nnav {\n    border-bottom-left-radius: 25px;\n    border-bottom-right-radius: 25px;\n    padding-bottom : 20px !important;\n    font-weight: 600 !important;\n}\n\n.select2 {\n    width: 100% !important;\n}\n\n.select2-container .select2-selection--single {\n    height: 42px !important;\n}\n\n.select2-container .select2-selection--multiple {\n    padding-top: 0px;\n}\n\n.select2-selection__choice {\n    margin-top: 8px !important;\n}\n\n.select-checkbox a {\n    padding-left: 5px;\n}\n\n.select2-selection__choice {\n    margin-top: 5px !important;\n}\n\n.shaded {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n\n.replay-controls {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    flex-wrap: wrap;\n}\n\n.replay-controls-left {\n    flex: 1;\n    min-width: 320px;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.replay-slider {\n    flex: 1;\n    width: 100%;\n    accent-color: #045fb0;\n}\n\n.replay-play-button {\n    min-width: 56px;\n}\n\n.replay-date-label {\n    font-weight: 600;\n    min-width: 220px;\n    flex: 0 0 220px;\n}\n\n.replay-speed-control {\n    min-width: 150px;\n}\n\n.replay-speed-control label {\n    letter-spacing: 0.05em;\n}\n\n.replay-season-controls {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.35rem;\n}\n\n.replay-season-dropdown {\n    padding-bottom: 0 !important;\n    margin-bottom: 0;\n}\n\n.replay-home-controls {\n    display: flex;\n    justify-content: flex-end;\n    align-items: stretch;\n    flex-wrap: wrap;\n}\n\n.watch-replay-btn {\n    border-color: #045fb0;\n    color: #045fb0 !important;\n    background-color: rgba(4, 95, 176, 0.08);\n    font-weight: 600;\n    min-height: 44px;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    padding: 0 1.05rem;\n    border-radius: 0.5rem;\n    box-shadow: inset 0 0 0 1px rgba(4,95,176,0.25);\n}\n\n.watch-replay-btn:hover {\n    background-color: #045fb0;\n    color: #fff !important;\n    box-shadow: inset 0 0 0 1px rgba(4,95,176,0.5);\n}\n\n.replay-marker-highlight {\n    background-color: rgba(4, 95, 176, 0.3);\n    box-shadow: inset 0 0 0 2px rgba(4, 95, 176, 0.4);\n    animation: replayMarkerPulse 1.6s ease-out forwards;\n}\n\n@keyframes replayMarkerPulse {\n    0% {\n        background-color: rgba(4, 95, 176, 0.45);\n        box-shadow: inset 0 0 0 2px rgba(4, 95, 176, 0.5);\n    }\n    60% {\n        background-color: rgba(4, 95, 176, 0.15);\n        box-shadow: inset 0 0 0 2px rgba(4, 95, 176, 0.2);\n    }\n    100% {\n        background-color: transparent;\n        box-shadow: none;\n    }\n}\n\n.replay-row-enter {\n    animation: replayRowEnter 1.6s ease-out;\n    animation-fill-mode: forwards;\n}\n\n@keyframes replayRowEnter {\n    0% {\n        background-color: rgba(4, 95, 176, 0.2);\n        transform: translateX(-6px);\n    }\n    50% {\n        background-color: rgba(4, 95, 176, 0.1);\n    }\n    100% {\n        background-color: transparent;\n        transform: translateX(0);\n    }\n}\n\n.short-row {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n}\n\n.no-padding {\n    padding: 0px !important;\n}\n\n/* Sortable Formset Styles */\n\n\n.drag-handle {\n    text-align: center;\n    vertical-align: middle;\n    cursor: move;\n    \n    i {\n        color: #6c757d;\n    }\n}\n\n[id$=\"-ORDER\"],\n[id$=\"-DELETE\"] {\n    display: none;\n}\n\n.mittab-dashboard {\n    .mittab-table-row:hover {\n        background-color: #f8f9fa !important;\n        transform: translateY(-1px);\n        transition: all 0.2s ease;\n    }\n    \n    .mittab-tournament-icon {\n        width: 40px;\n        height: 40px;\n        background: #007bff;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: white;\n        font-size: 1.1rem;\n    }\n    \n    .mittab-stat-item {\n        padding: 1rem;\n        border-radius: 8px;\n        transition: transform 0.2s ease;\n        \n        &:hover {\n            transform: translateY(-2px);\n        }\n    }\n    \n    .mittab-table {\n        box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n        border-radius: 8px;\n        overflow: hidden;\n    }\n    \n    .mittab-btn-primary {\n        background: #007bff;\n        transition: all 0.2s ease;\n        \n        &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 4px 8px rgba(115, 29, 221, 0.3);\n            background: #731DDD;\n        }\n    }\n    \n    .mittab-refresh-btn {\n        transition: all 0.2s ease;\n        \n        &:hover {\n            transform: translateY(-1px);\n        }\n    }\n}\n\n.rankings-card {\n    border-radius: 8px;\n    \n    .rankings-warning {\n        border-left: 4px solid #ffc107;\n    }\n    \n    .form-control:focus {\n        border-color: #731DDD;\n        box-shadow: 0 0 0 0.2rem rgba(115, 29, 221, 0.25);\n    }\n    \n    .btn:hover:not(:disabled) {\n        transform: translateY(-1px);\n    }\n}\n\n.card {\n    overflow: visible !important;\n}\n\n.tab-pane.table-responsive {\n    overflow: visible !important;\n}\n\n.dropdown-menu {\n    z-index: 1050 !important;\n}\n\n.outreach-available {\n    color: #0d7d3e;\n    font-weight: 500;\n}\n\n\n@import \"node_modules/bootstrap/scss/bootstrap\";\n","/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
